import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { twoPlusAction } from "../../_actions/twoplus.actions";
import moment from "moment";
import {
  Button,
  Descriptions,
  Drawer,
  PageHeader,
  Space,
  Table,
  Input,
  Tag,
  Spin,
  Typography,
  Collapse,
  Tooltip,
  Badge,
  Dropdown,
  Select,
  Card,
  Row,
  Col,
  Empty,
  Radio,
} from "antd";
import { AropiInfoTable } from "./AropiInfoTable";
import Modal from "antd/lib/modal/Modal";
import { ViewFormModel } from "./ViewForm/ViewFormModel";
import Highlighter from "react-highlight-words";
import {
  BankOutlined,
  FileTextOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { ImageView } from "../image/imageView";
import { LanguageContext } from "../../context/LanguageContext";
import {
  BarChartOutlined,
  UnorderedListOutlined,
  AreaChartOutlined,
} from "@ant-design/icons";
import { connect } from "react-redux";
import { professionalAction } from "../../_actions";
import { ViewGunaDetails } from "../viewGunaDetails/viewGunaDetails";
import { ViewPrevetiveDetails } from "../viewPreventive/viewPreventive";
import * as XLSX from "xlsx-js-style";
import _ from "lodash";
import { adminServiceAction } from "../../_actions/admin.service";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  LabelList,
  Line,
  LineChart,
  Area,
  AreaChart,
  Pie,
  PieChart,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip as RechartsTooltip,
  XAxis,
  YAxis,
} from "recharts";
const { Panel } = Collapse;
const { Option } = Select;
const { Text, Title } = Typography;

const PREVENTIVE_ACTION_COLUMNS = [
  "सीआरपीसी कलम 107",
  "सीआरपीसी कलम 110",
  "सीआरपीसी कलम 144 (3)",
  "मपोका कलम 68/69",
  "मपोका कलम 55",
  "मपोका कलम 56",
  "मपोका कलम 57",
  "मंबई दारूबंदी कायदा कलम 93",
  "महाराष्ट्र संघटित गन्हेगारी अधधतियम (मोक्का)",
  "सीआरपीसी कलम 109",
  "सीआरपीसी कलम 151",
  "एम पी डी ए सीआरपीसी कलम 151(3)",
  "बी एन एस एस १२६",
  "बी एन एस एस १२७",
  "बी एन एस एस १२८",
  "बी एन एस एस १२९",
];

const PIE_COLORS = [
  "#2563eb",
  "#16a34a",
  "#f59e0b",
  "#dc2626",
  "#7c3aed",
  "#0891b2",
  "#db2777",
  "#65a30d",
  "#9333ea",
  "#0ea5e9",
  "#ea580c",
  "#64748b",
  "#14b8a6",
];

const styles = {
  pageContainer: {
    padding: "16px 0",
    width: "100%",
  },
  headerCard: {
    background: "#fff",
    borderRadius: "8px",
    border: "1px solid #f0f0f0",
    boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
    marginBottom: "16px",
  },
  filterSection: {
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  filterRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: "16px",
    alignItems: "flex-start",
    width: "100%",
  },
  formItem: {
    flex: "1 1 280px",
    minWidth: "280px",
    marginBottom: 0,
  },
  selectInput: {
    width: "100%",
  },
  buttonGroup: {
    display: "flex",
    gap: "8px",
    flexWrap: "wrap",
    alignItems: "flex-end",
  },
  actionButton: {
    minWidth: "120px",
    height: "32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
  },
  viewTypeSection: {
    display: "flex",
    flexWrap: "wrap",
    gap: "12px",
    alignItems: "center",
    padding: "12px",
    background: "#f5f5f5",
    borderRadius: "8px",
    boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
    marginBottom: "16px",
  },
  totalCount: {
    padding: "4px 12px",
    background: "#fff",
    borderRadius: "4px",
    border: "1px solid #d9d9d9",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    background: "#6f42c1",
  },
  totalPhoto: {
    padding: "4px 12px",
    background: "#fff",
    borderRadius: "4px",
    border: "1px solid #d9d9d9",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    background: "#28a745",
  },
  analyticalBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    background: "#1a3a6c",
    color: "#fff",
    padding: "10px 16px",
    borderRadius: "8px",
    fontSize: "0.9rem",
    whiteSpace: "nowrap",
    cursor: "pointer",
    lineHeight: 1,
  },
  tableContainer: {
    width: "100%",
    overflowX: "auto",
    background: "#fff",
    borderRadius: "8px",
    border: "1px solid #f0f0f0",
    boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
  },
  graphCard: {
    borderRadius: 12,
    border: "1px solid #e8e8e8",
    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
    overflow: "hidden",
  },
  graphLegendItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 12px",
    borderRadius: 8,
    marginBottom: 8,
    background: "#fafafa",
    border: "1px solid #f0f0f0",
  },
  graphLegendDot: {
    width: 10,
    height: 10,
    borderRadius: "50%",
    flexShrink: 0,
    marginRight: 10,
  },
  graphPageHeader: {
    padding: "14px 20px",
    borderBottom: "1px solid #f0f0f0",
    background: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 12,
  },
  graphHeaderTotal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    flexWrap: "wrap",
    gap: 10,
  },
  graphStatBadge: {
    display: "inline-flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 88,
    padding: "8px 16px",
    borderRadius: 8,
    border: "1px solid transparent",
    boxShadow: "0 1px 2px rgba(0,0,0,0.06)",
    cursor: "default",
  },
  graphStatBadgeLabel: {
    fontSize: 11,
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.3px",
    marginBottom: 2,
    lineHeight: 1.2,
  },
  graphStatBadgeValue: {
    fontSize: 20,
    fontWeight: 700,
    lineHeight: 1.1,
  },
  graphSectionHeaderRow: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 12,
    marginBottom: 16,
  },
  graphSectionHeaderLeft: {
    flex: 1,
    minWidth: 200,
  },
  graphSection: {
    background: "#fafafa",
    border: "1px solid #eef0f3",
    borderRadius: 10,
    padding: "16px 18px",
    marginBottom: 20,
  },
  graphSectionTitle: {
    margin: "0 0 4px 0",
    fontSize: 15,
    fontWeight: 600,
    color: "#1d39c4",
  },
  graphSectionSubtitle: {
    fontSize: 12,
    color: "#8c8c8c",
    marginBottom: 0,
    display: "block",
  },
  dateWiseChartWrap: {
    background: "#000",
    borderRadius: 12,
    padding: "20px 16px 12px",
    minHeight: 360,
    display: "flex",
    flexDirection: "column",
  },
  dateWiseChartHeader: {
    color: "#fff",
    fontSize: 18,
    fontWeight: 600,
    marginBottom: 8,
    letterSpacing: "0.3px",
  },
  dateWiseChartBody: {
    width: "100%",
    height: 300,
  },
  dateWisePeriodRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: 6,
    marginTop: 12,
    paddingTop: 8,
  },
  dateWisePeriodBtn: {
    border: "none",
    background: "transparent",
    color: "#fff",
    fontSize: 13,
    fontWeight: 500,
    padding: "4px 10px",
    borderRadius: 999,
    cursor: "pointer",
    lineHeight: 1.4,
  },
  dateWisePeriodBtnActive: {
    border: "1px solid #fff",
    background: "rgba(255,255,255,0.08)",
  },
};

const GRAPH_TIME_RANGES = [
  { key: "1D", label: "1D" },
  { key: "1W", label: "1W" },
  { key: "1M", label: "1M" },
  { key: "3M", label: "3M" },
  { key: "6M", label: "6M" },
  { key: "1Y", label: "1Y" },
  { key: "5Y", label: "5Y" },
  { key: "All", label: "All" },
];

const GRAPH_MONTH_TIME_RANGES = [
  { key: "6M", label: "6M" },
  { key: "1Y", label: "1Y" },
  { key: "3Y", label: "3Y" },
  { key: "5Y", label: "5Y" },
  { key: "All", label: "All" },
];

const GRAPH_MONTH_TIME_RANGE_KEYS = GRAPH_MONTH_TIME_RANGES.map((r) => r.key);

const parseMappedDistrictIds = (raw) => {
  if (Array.isArray(raw)) {
    return raw
      .map((id) => Number(id))
      .filter((id) => Number.isFinite(id));
  }
  if (raw === null || raw === undefined || raw === "") return [];
  if (typeof raw === "string") {
    const trimmed = raw.trim();
    if (trimmed.startsWith("[")) {
      try {
        return parseMappedDistrictIds(JSON.parse(trimmed));
      } catch (e) {
        /* fall through */
      }
    }
    return trimmed
      .replace(/[\[\]]/g, "")
      .split(",")
      .map((id) => Number(String(id).trim()))
      .filter((id) => Number.isFinite(id));
  }
  const parsed = Number(raw);
  return Number.isFinite(parsed) ? [parsed] : [];
};

const GRAPH_STAT_BADGE_THEMES = {
  total: {
    background: "#e6f4ff",
    borderColor: "#91caff",
    labelColor: "#0958d9",
    valueColor: "#1d39c4",
  },
  actions: {
    background: "#f9f0ff",
    borderColor: "#d3adf7",
    labelColor: "#531dab",
    valueColor: "#722ed1",
  },
  district: {
    background: "#f6ffed",
    borderColor: "#b7eb8f",
    labelColor: "#389e0d",
    valueColor: "#237804",
  },
};

const AropiReport2Plus = ({
  report_type,
  startDate,
  endDate,
  cityId,
  newArophiData,
  arophiCount,
  arophiList,
  arophiListCount,
  historyList,
  historyCount,
  showList,
  getShowList,
  onViewAccusedForm,
  user,
  total,
  loading,
  professionals,
  dispatch,
  preventiveAction,
  filter,
  selectedCity,
  hideGraphButton = false,
  graphOnly = false,
  graphRefreshKey = 0,
  graphPeriodLabel = "",
  showGraphToggle = false,
  isGraphView = false,
  onToggleGraph,
  onTableSortChange,
  onDistrictFilterChange,
  onPreventiveFilterChange,
  onVisibleRowsChange,
}) => {
  console.log("loader", loading);
  console.log("professionals", professionals);
  const [aropiInfoDrawer, setAropiInfoDrawer] = useState(false);
  const [criminalList, setCriminalList] = useState([]);
  const [searchedColumn, setSearchedColumn] = useState();
  const [searchText, setSearchText] = useState("");
  const [searchInput, setsearchInput] = useState();
  const { language, setLanguage, t } = useContext(LanguageContext);
  const [showGunaDetails, setshowGunaDetails] = useState(false);
  const [gunaLoading, setGunaLoading] = useState(false);
  const [showPreventiveDetails, setShowPreventiveDetails] = useState(false);
  const [preventiveLoading, setPreventiveLoading] = useState(false);
  const [loadingList, setLoadingList] = useState(false);
  const [info, setInfo] = useState();
  const [tablePreventiveFilters, setTablePreventiveFilters] = useState([]);
  const [preventiveGraphData, setPreventiveGraphData] = useState([]);
  const [preventiveGraphLoading, setPreventiveGraphLoading] = useState(false);
  const [graphViewType, setGraphViewType] = useState("preventive_action");
  const [graphTimeRange, setGraphTimeRange] = useState("1Y");
  const [dateWiseLineData, setDateWiseLineData] = useState([]);
  const [dateWiseGraphTotal, setDateWiseGraphTotal] = useState(0);
  const [dateWiseGraphLoading, setDateWiseGraphLoading] = useState(false);
  const [dateWiseActivePoint, setDateWiseActivePoint] = useState(null);

  const [graphType, setGraphType] = useState("trend_graph");
  const [dateWiseGranularity, setDateWiseGranularity] = useState("day");
  const onChangeGraphType = (e) => {
    setGraphType(e.target.value);
  };
  const getGraphTitleParam = (viewType) => {
    if (viewType === "shirshak") return "शीर्षक";
    if (viewType === "laghushirshak") return "लघुशीर्षक";
    return "प्रतिबंधक कारवाई";
  };

  const getGraphRangeDates = (rangeKey) => {
    const end = moment().endOf("day");
    let start;

    switch (rangeKey) {
      case "1D":
        start = moment().startOf("day");
        break;
      case "1W":
        start = moment().subtract(7, "days").startOf("day");
        break;
      case "1M":
        start = moment().subtract(1, "month").startOf("day");
        break;
      case "3M":
        start = moment().subtract(3, "months").startOf("day");
        break;
      case "6M":
        start = moment().subtract(6, "months").startOf("day");
        break;
      case "1Y":
        start = moment().subtract(1, "year").startOf("day");
        break;
      case "3Y":
        start = moment().subtract(3, "years").startOf("day");
        break;
      case "5Y":
        start = moment().subtract(5, "years").startOf("day");
        break;
      case "All":
        start = moment("2000-01-01").startOf("day");
        break;
      default:
        start = moment().subtract(1, "year").startOf("day");
    }

    return {
      startDate: start.format("YYYY-MM-DD"),
      endDate: end.format("YYYY-MM-DD"),
    };
  };

  const fetchDateWiseGraphData = (rangeKey = graphTimeRange) => {
    const resolvedCityId = user?.role === "12" ? selectedCity : user?.cityId;

    if (!resolvedCityId) {
      setDateWiseLineData([]);
      setDateWiseGraphTotal(0);
      setDateWiseActivePoint(null);
      return;
    }

    const { startDate: rangeStart, endDate: rangeEnd } =
      getGraphRangeDates(rangeKey);

    setDateWiseGraphLoading(true);
    const graphRequest = {
      startDate: rangeStart,
      endDate: rangeEnd,
      cityId: resolvedCityId,
      granularity: dateWiseGranularity,
    };
    const isCumulative = graphType === "cummulative_graph";
    const graphApi =
      filter === "by_id"
        ? isCumulative
          ? adminServiceAction.get2PlusNewAropiPostBharaliCumulativeCountGraph(
              graphRequest,
            )
          : adminServiceAction.get2PlusNewAropiPostBharaliCountGraph(
              graphRequest,
            )
        : isCumulative
          ? adminServiceAction.get2plusByIdCumulativeCountGraph(graphRequest)
          : adminServiceAction.get2plusByIdCountGraph(graphRequest);

    graphApi
      .then((res) => {
        const lineData = Array.isArray(res?.results) ? res.results : [];
        setDateWiseLineData(lineData);
        setDateWiseGraphTotal(Number(res?.total ?? 0));
        setDateWiseActivePoint(lineData[lineData.length - 1] || null);
      })
      .catch((err) => {
        console.error("Date-wise graph error:", err);
        setDateWiseLineData([]);
        setDateWiseGraphTotal(0);
        setDateWiseActivePoint(null);
      })
      .finally(() => {
        setDateWiseGraphLoading(false);
      });
  };

  useEffect(() => {
    if (
      report_type === "arophi count" &&
      showList === "graph" &&
      graphViewType === "date_wise"
    ) {
      fetchDateWiseGraphData(graphTimeRange);
    }
  }, [
    selectedCity,
    graphRefreshKey,
    graphViewType,
    graphTimeRange,
    showList,
    filter,
    report_type,
    graphType,
    dateWiseGranularity,
  ]);

  const fetchPreventiveActionGraph = () => {
    if (!startDate || !endDate) return;

    const formattedStart = moment(startDate).format("YYYY-MM-DD");
    const formattedEnd = moment(endDate).format("YYYY-MM-DD");
    if (!moment(formattedStart).isValid() || !moment(formattedEnd).isValid()) {
      return;
    }

    setPreventiveGraphLoading(true);
    const graphTitle = getGraphTitleParam(graphViewType);
    const isOfficer = user?.role === "9" || user?.role === "10";
    const isPoliceRole = user?.role === "2";
    const resolvedCityId = user?.role === "12" ? selectedCity : user?.cityId;
    const districtIds = parseMappedDistrictIds(user?.map_districtId);

    const officerGraphObj = {
      startDate: formattedStart,
      endDate: formattedEnd,
      districtIds,
      title: graphTitle,
      filter,
    };
    const cityGraphObj = {
      startDate: formattedStart,
      endDate: formattedEnd,
      cityId: resolvedCityId,
      title: graphTitle,
      filter,
    };
    const districtGraphObj = {
      startDate: formattedStart,
      endDate: formattedEnd,
      districtId: user?.districtId,
      title: graphTitle,
      filter,
    };
    const preventiveDistrictObj = {
      startDate: formattedStart,
      endDate: formattedEnd,
      cityId: resolvedCityId,
      district: user?.districtId,
      title: graphTitle,
      filter,
    };

    const graphObj = isOfficer
      ? officerGraphObj
      : isPoliceRole
        ? districtGraphObj
        : cityGraphObj;

    if (isOfficer && districtIds.length === 0) {
      setPreventiveGraphData([]);
      setPreventiveGraphLoading(false);
      return;
    }

    let apiPromise = null;
    if (report_type === "more_than_two_plus_list") {
      apiPromise = isPoliceRole
        ? adminServiceAction.get2plusNewArophiPreventiveActionPoliceStationCount(
            preventiveDistrictObj,
          )
        : adminServiceAction.get2plusNewArophiPreventiveActionCount(graphObj);
    } else if (report_type === "arophi count") {
      apiPromise = adminServiceAction.get2lusArophiCountGraph(graphObj);
    } else if (report_type === "arophi_new_list") {
      apiPromise = adminServiceAction.get2lusNewListAropiGraph(graphObj);
    }

    if (!apiPromise) {
      setPreventiveGraphData([]);
      setPreventiveGraphLoading(false);
      return;
    }

    apiPromise
      .then((res) => {
        setPreventiveGraphData(res?.results || []);
      })
      .catch((err) => {
        console.error("Graph data error:", err);
        setPreventiveGraphData([]);
      })
      .finally(() => {
        setPreventiveGraphLoading(false);
      });
  };

  const handleGraphTimeRangeClick = (rangeKey) => {
    setGraphTimeRange(rangeKey);
  };

  const activeTimeRanges =
    dateWiseGranularity === "month"
      ? GRAPH_MONTH_TIME_RANGES
      : GRAPH_TIME_RANGES;

  const onChangeGranularity = (value) => {
    setDateWiseGranularity(value);
    if (
      value === "month" &&
      !GRAPH_MONTH_TIME_RANGE_KEYS.includes(graphTimeRange)
    ) {
      setGraphTimeRange("1Y");
    }
  };

  const handleGraphClick = () => {
    getShowList("graph");
    // fetchPreventiveActionGraph();
  };

  useEffect(() => {
    if (showList === "graph" && graphViewType !== "date_wise") {
      fetchPreventiveActionGraph();
    }
  }, [
    startDate,
    endDate,
    selectedCity,
    graphRefreshKey,
    graphViewType,
    showList,
    filter,
    report_type,
  ]);

  const graphTimeRangeLabel = useMemo(() => {
    const { startDate, endDate } = getGraphRangeDates(graphTimeRange);
    const rangeLabel =
      [...GRAPH_TIME_RANGES, ...GRAPH_MONTH_TIME_RANGES].find(
        (range) => range.key === graphTimeRange,
      )?.label || graphTimeRange;
    return `${rangeLabel}: ${moment(startDate).format("DD-MM-YYYY")} — ${moment(endDate).format("DD-MM-YYYY")}`;
  }, [graphTimeRange]);

  const getCityName = (id) => {
    const { pc_cities } = professionals;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };

  const download_csv = () => {
    /* ===================== FILE / REPORT NAMES ===================== */

    const report_name =
      report_type === "new arophi"
        ? t("accused_new_cases_statistics")
        : report_type === "arophi count" ||
            (report_type === "more_than_two_plus_list" &&
              showList === "सांख्यिकी")
          ? t("two_plus_accused")
          : report_type === "arophi_new_list"
            ? t("two_plus_accused_list")
            : t("two_plus_accused");

    const file_name = `${report_name}_${moment().format("DDMMMYYYY")}`;

    const Report =
      report_type === "new arophi"
        ? t("accused_new_cases_statistics")
        : report_type === "arophi count"
          ? t("2_plus_report")
          : report_type === "arophi_new_list"
            ? t("two_plus_accused_list")
            : report_type === "more_than_two_plus_list"
              ? t("accused_combined_list_2_plus")
              : t("2_plus_report");

    const ReportSubTitle =
      filter === "by_distinct"
        ? report_type === "arophi count" ||
          report_type === "more_than_two_plus_list"
          ? t("info_within_police_station_limits")
          : t("info_within_police_station_crime")
        : report_type === "arophi count" ||
            report_type === "more_than_two_plus_list"
          ? t("data_entered_by_police_station")
          : t("data_entered_by_police_crime");

    const ReportTitle = `${Report} - ${ReportSubTitle}`;

    /* ===================== STYLES ===================== */

    const titleStyle = {
      font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
    };

    const subTitleStyle = {
      font: { bold: true, sz: 12, color: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
    };

    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "305496" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    const cellStyle = {
      // alignment: { vertical: "top", wrapText: true },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    /* ===================== WORKBOOK ===================== */

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet([]);
    const merges = [];
    const totalCols = 16;

    const cityName =
      user.role === "12"
        ? getCityName(selectedCity)
        : getCityName(user?.cityId || "");
    const dateRange = `${t("from")} ${moment(startDate).format(
      "DD-MM-YYYY",
    )} - ${t("to")} ${moment(endDate).format("DD-MM-YYYY")}`;

    /* ===================== TITLES ===================== */

    XLSX.utils.sheet_add_aoa(ws, [[`${info.districtName} (${cityName})`]], {
      origin: "A1",
    });
    ws["A1"].s = titleStyle;
    merges.push({ s: { r: 0, c: 0 }, e: { r: 0, c: totalCols - 1 } });

    XLSX.utils.sheet_add_aoa(ws, [[ReportTitle]], { origin: "A2" });
    ws["A2"].s = subTitleStyle;
    merges.push({ s: { r: 1, c: 0 }, e: { r: 1, c: totalCols - 1 } });

    XLSX.utils.sheet_add_aoa(ws, [[dateRange]], { origin: "A3" });
    ws["A3"].s = subTitleStyle;
    merges.push({ s: { r: 2, c: 0 }, e: { r: 2, c: totalCols - 1 } });

    /* ===================== HEADERS ===================== */

    const currentStatusLabel = `${t("current_status")} (${moment().format(
      "DD-MM-YYYY",
    )})`;

    const headers = [
      t("sr.no"),
      t("accused_police_station"),
      t("name"),
      t("address"),
      t("total_crimes"),
      t("photo"),
      t("title"),
      t("crime_police_station"),
      t("crime_register_number"),
      t("crime_register_year"),
      t("crime_registration_date"),
      t("law_and_section"),
      t("preventive_action"),
      currentStatusLabel,
      t("date_from"),
      t("date_to"),
    ];

    XLSX.utils.sheet_add_aoa(ws, [headers], { origin: "A4" });
    headers.forEach((_, c) => {
      ws[XLSX.utils.encode_cell({ r: 3, c })].s = headerStyle;
    });

    /* ===================== DATA (FIXED) ===================== */

    const ws_data = [];
    const accusedFixedCols = 6;

    criminalList.forEach((accused, idx) => {
      const gunhas = accused.gunha_records || [];
      const preventive = accused.prevetive_records || [];

      const maxRows = Math.max(gunhas.length, preventive.length, 1);

      for (let i = 0; i < maxRows; i++) {
        const row = [];

        /* ACCUSED */
        if (i === 0) {
          row.push(
            idx + 1,
            accused.districtName || accused.crime_districtName || "-",
            accused.name || "-",
            accused.address || "-",
            accused.totalCrimeCount || "-",
            accused.photo?.length && accused.photo[0] !== "" ? "Yes" : "No",
          );
        } else {
          for (let k = 0; k < accusedFixedCols; k++) row.push("");
        }

        /* GUNHA */
        const gunha = gunhas[i];
        if (gunha) {
          row.push(
            gunha.crime_title || "-",
            gunha.districtName || "-",
            gunha.registernumber || "-",
            gunha.registernumberYear
              ? moment(gunha.registernumberYear).format("YYYY")
              : "-",
            gunha.dateTime ? moment(gunha.dateTime).format("DD/MM/YYYY") : "-",
          );

          let lawData = "-";
          if (gunha.kk_info?.length) {
            const grouped = {};
            gunha.kk_info.forEach((r) => {
              const name = r.rulesName || "-";
              const kalma = r.kalam || "-";
              grouped[name] = grouped[name]
                ? Array.from(new Set([...grouped[name], kalma]))
                : [kalma];
            });
            lawData = Object.entries(grouped)
              .map(([n, k]) => `${n}: ${k.join(", ")}`)
              .join("\n");
          }
          row.push(lawData);
        } else {
          row.push("", "", "", "", "", "");
        }

        /* PREVENTIVE */
        const action = preventive[i];
        if (action) {
          row.push(
            action.preventive_action_name || "-",
            action.date_to && moment(action.date_to).isBefore(moment(), "day")
              ? t("completed")
              : t("ongoing"),
            action.date_from
              ? moment(action.date_from).format("DD-MM-YYYY")
              : "-",
            action.date_to ? moment(action.date_to).format("DD-MM-YYYY") : "-",
          );
        } else {
          row.push("", "", "", "");
        }

        ws_data.push(row);
      }
    });

    XLSX.utils.sheet_add_aoa(ws, ws_data, { origin: "A5" });

    ws_data.forEach((row, r) =>
      row.forEach((_, c) => {
        const cell = XLSX.utils.encode_cell({ r: r + 4, c });
        if (ws[cell]) ws[cell].s = cellStyle;
      }),
    );

    const footerRowIndex = ws_data.length + 6;

    const footerContent = `Generated At ${moment().format(
      "DD MMM YYYY",
    )} From Criminal Monitoring Intelligent System`;

    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });

    ws[`A${footerRowIndex}`].s = {
      font: { italic: true, sz: 11, color: { rgb: "555555" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    merges.push({
      s: { r: footerRowIndex - 1, c: 0 },
      e: { r: footerRowIndex - 1, c: totalCols - 1 },
    });
    /* ===================== WIDTH / HEIGHT ===================== */

    ws["!cols"] = [
      { wch: 6 },
      { wch: 18 },
      { wch: 18 },
      { wch: 28 },
      { wch: 12 },
      { wch: 8 },
      { wch: 18 },
      { wch: 18 },
      { wch: 16 },
      { wch: 14 },
      { wch: 16 },
      { wch: 36 },
      { wch: 22 },
      { wch: 18 },
      { wch: 14 },
      { wch: 14 },
    ];

    ws["!rows"] = [{ hpt: 38 }, { hpt: 30 }, { hpt: 28 }, { hpt: 42 }];

    for (let i = 4; i < ws_data.length + 4; i++) {
      ws["!rows"][i] = { hpt: 44 };
    }
    ws["!rows"][footerRowIndex - 1] = { hpt: 28 };
    ws["!freeze"] = { ySplit: 4 };
    ws["!merges"] = merges;

    XLSX.utils.book_append_sheet(wb, ws, "Report");
    XLSX.writeFile(wb, `${file_name}.xlsx`);
  };

  const showGunaViewModel = () => {
    setshowGunaDetails(true);
  };
  const closeGunaViewModel = () => {
    setshowGunaDetails(false);
  };
  const onGunaForm = (data) => {
    showGunaViewModel();
    if (data) {
      setGunaLoading(true);
      dispatch({ type: "GET_CRIMINALS_BY_ID_SUCCESS", criminalViewList: {} });
      dispatch(professionalAction.getCriminalsViewsById(data));
    }
  };
  const showpreventiveViewModel = () => {
    setShowPreventiveDetails(true);
  };
  const closepreventiveViewModel = () => {
    setShowPreventiveDetails(false);
  };
  const onpreventiveForm = (data) => {
    showpreventiveViewModel();
    if (data) {
      setPreventiveLoading(true);
      dispatch({ type: "GET_CRIMINALS_BY_ID_SUCCESS", criminalViewList: {} });
      dispatch(professionalAction.getCriminalsViewsById(data));
    }
  };
  useEffect(() => {
    // If gunaLoading is true and we have received new data, stop loading
    if (
      gunaLoading &&
      professionals?.criminalViewList &&
      Object.keys(professionals.criminalViewList).length > 0
    ) {
      setGunaLoading(false);
    }
  }, [professionals?.criminalViewList]);

  useEffect(() => {
    // If gunaLoading is true and we have received new data, stop loading
    if (
      preventiveLoading &&
      professionals?.criminalViewList &&
      Object.keys(professionals.criminalViewList).length > 0
    ) {
      setPreventiveLoading(false);
    }
  }, [professionals?.criminalViewList]);

  const searchInputRef = useRef(null);

  const startDate1 = startDate;
  const endDate1 = endDate;

  const showpreventiveDrawer = (districtName) => {
    setAropiInfoDrawer(true);
    getCriminalList(districtName);
  };

  const showhistoryPreventiveDrawer = (districtName) => {
    setAropiInfoDrawer(true);
    // getHistoryCriminalList(districtName);
  };

  const getCriminalList = (districtName) => {
    console.log("report type", report_type);
    let startDate = moment(startDate1).format("YYYY-MM-DD");
    let endDate = moment(endDate1).format("YYYY-MM-DD");
    setLoadingList(true);
    if (["4", "12","9","10"].includes(user.role)) {
      if (report_type === "arophi count") {
        if (filter === "by_distinct") {
          const temp = {
            startDate: startDate,
            endDate: endDate,
            cityId: user.role === "12" ? selectedCity : user && user.cityId,
            district: districtName,
          };
          twoPlusAction.get2PlusNewArophiList(temp).then((res) => {
            res &&
              res.text().then((criminalList1) => {
                let criminal = JSON.parse(criminalList1);
                let list = criminal.results;
                setCriminalList(list);
                setLoadingList(false);
              });
          });
        }
        if (filter === "by_id") {
          let obj = {
            startDate: startDate,
            endDate: endDate,
            cityId: user.role === "12" ? selectedCity : user && user.cityId,
            district: districtName,
          };
          twoPlusAction.get2PlusNewAropiPostBharaliList(obj).then((res) => {
            res &&
              res.text().then((criminalList1) => {
                let criminal = JSON.parse(criminalList1);
                let list = criminal.results;
                setCriminalList(list);
                setLoadingList(false);
              });
          });
        }
      }
      if (report_type === "more_than_two_plus_list") {
        if (filter === "by_distinct") {
          const temp = {
            startDate: startDate,
            endDate: endDate,
            cityId: user.role === "12" ? selectedCity : user && user.cityId,
            district: districtName,
          };
          adminServiceAction
            .getAccusedListWithTwoOrMoreListByDistinct(temp)
            .then((res) => {
              let list = res.results;
              setCriminalList(list);
              setLoadingList(false);
            });
        }
        if (filter === "by_id") {
          let obj = {
            startDate: startDate,
            endDate: endDate,
            cityId: user.role === "12" ? selectedCity : user && user.cityId,
            district: districtName,
          };
          adminServiceAction
            .getAccusedListWithTwoOrMoreListById(obj)
            .then((res) => {
              let list = res.results;
              setCriminalList(list);
              setLoadingList(false);
            });
        }
      }
      if (report_type === "arophi_new_list") {
        if (filter === "by_distinct") {
          const temp = {
            startDate: startDate,
            endDate: endDate,
            cityId: user.role === "12" ? selectedCity : cityId,
            district: districtName,
            direction: "",
          };
          twoPlusAction.get2lusArophiListCount(temp).then((res) => {
            res &&
              res.text().then((criminalList1) => {
                let criminal = JSON.parse(criminalList1);
                let list = criminal.results;
                setCriminalList(list);
                setLoadingList(false);
              });
          });
        }
        if (filter === "by_id") {
          let obj = {
            startDate: startDate,
            endDate: endDate,
            cityId: user.role === "12" ? selectedCity : cityId,
            district: districtName,
            direction: "",
          };
          twoPlusAction.get2lusArophiPostBharaliList(obj).then((res) => {
            res &&
              res.text().then((criminalList1) => {
                let criminal = JSON.parse(criminalList1);
                let list = criminal.results;
                setCriminalList(list);
                setLoadingList(false);
              });
          });
        }
      }
    }
    if (user?.role === "9" || user?.role === "10") {
      if (filter === "by_distinct") {
        if (report_type === "arophi count") {
          let obj = {
            startDate: startDate,
            endDate: endDate,
            districtId: [districtName],
            direction: "",
          };
          twoPlusAction.getPlus2ArophiListByRole(obj).then((res) => {
            res &&
              res.text().then((criminalList1) => {
                let criminal = JSON.parse(criminalList1);
                let list = criminal.results;
                setCriminalList(list);
                setLoadingList(false);
              });
          });
        }
        if (report_type === "arophi_new_list") {
          let obj = {
            startDate: startDate,
            endDate: endDate,
            districtId: [districtName],
            direction: "",
          };
          twoPlusAction.get2lusArophiListCountByRole(obj).then((res) => {
            res &&
              res.text().then((criminalList1) => {
                let criminal = JSON.parse(criminalList1);
                let list = criminal.results;
                setCriminalList(list);
                setLoadingList(false);
              });
          });
        }
      }
      if (filter === "by_id") {
        let obj = {
          startDate: startDate,
          endDate: endDate,
          districtId: [districtName],
        };
        if (report_type === "arophi count") {
          twoPlusAction
            .get2PlusNewAropiPostBharaliListByRole(obj)
            .then((res) => {
              res &&
                res.text().then((criminalList1) => {
                  let criminal = JSON.parse(criminalList1);
                  let list = criminal.results;
                  setCriminalList(list);
                  setLoadingList(false);
                });
            });
        }
        if (report_type === "arophi_new_list") {
          twoPlusAction.get2lusArophiPostBharaliListByRole(obj).then((res) => {
            res &&
              res.text().then((criminalList1) => {
                let criminal = JSON.parse(criminalList1);
                let list = criminal.results;
                setCriminalList(list);
                setLoadingList(false);
              });
          });
        }
      }
    }
  };

  const getHistoryCriminalList = (districtName) => {
    if (user.role === "4") {
      twoPlusAction
        .getCriminalHistoryDetails(cityId, districtName)
        .then((res) => {
          res &&
            res.text().then((criminalList1) => {
              let criminal = JSON.parse(criminalList1);
              let list = criminal.results;
              setCriminalList(list);
            });
        });
    }
    if (user?.role === "9" || user?.role === "10") {
      let districtobj = {
        districtId: [districtName],
      };
      twoPlusAction.getHistorySheeterListByRole(districtobj).then((res) => {
        res &&
          res.text().then((criminalList1) => {
            let criminal = JSON.parse(criminalList1);
            let list = criminal.results;
            setCriminalList(list);
          });
      });
    }
  };

  const onCloseAropiInfo = () => {
    setCriminalList([]);
    setAropiInfoDrawer(false);
    setInfo(undefined);
  };

  const getPreventiveActionIdByName = (name) => {
    const idx = PREVENTIVE_ACTION_COLUMNS.indexOf(name);
    return idx >= 0 ? idx + 1 : null;
  };

  const fetchGraphCrimeDetails = (segment) => {
    if (!segment?.name || segment.name === "Others") return;

    const formattedStart = moment(startDate1).format("YYYY-MM-DD");
    const formattedEnd = moment(endDate1).format("YYYY-MM-DD");
    if (!moment(formattedStart).isValid() || !moment(formattedEnd).isValid()) {
      return;
    }

    setAropiInfoDrawer(true);
    setLoadingList(true);
    setInfo({
      districtName: segment.name,
      graphFilter: segment.name,
      graphCount: Number(segment.count ?? segment.value ?? 0),
    });

    const request = {
      startDate: formattedStart,
      endDate: formattedEnd,
      order_by: "",
      direction: "",
    };

    if (
      graphViewType === "shirshak" &&
      segment.headingId != null &&
      segment.headingId !== "" &&
      !Number.isNaN(Number(segment.headingId))
    ) {
      request.heading = [Number(segment.headingId)];
    } else if (
      graphViewType === "laghushirshak" &&
      segment.typeId != null &&
      segment.typeId !== "" &&
      !Number.isNaN(Number(segment.typeId))
    ) {
      request.crimeTypeId = Number(segment.typeId);
    } else if (graphViewType === "preventive_action") {
      const preventiveActionId =
        segment.preventiveActionId || getPreventiveActionIdByName(segment.name);
      if (!preventiveActionId) {
        setLoadingList(false);
        return;
      }
      request.preventiveActionId = preventiveActionId;
    }

    const applyListResults = (list) => {
      const uniqueList = [];
      const seen = new Set();
      (Array.isArray(list) ? list : []).forEach((row) => {
        const key = row?.masterId ?? row?.id;
        if (key != null) {
          const idKey = String(key);
          if (seen.has(idKey)) return;
          seen.add(idKey);
        }
        uniqueList.push(row);
      });
      setCriminalList(uniqueList);
      setInfo((prev) =>
        prev
          ? {
              ...prev,
              graphCount: uniqueList.length,
            }
          : prev,
      );
      setLoadingList(false);
    };

    const handleListError = () => {
      setCriminalList([]);
      setLoadingList(false);
    };

    const parseFetchListResponse = (res) => {
      if (!res) {
        handleListError();
        return;
      }
      res
        .text()
        .then((text) => {
          const criminal = text ? JSON.parse(text) : {};
          applyListResults(criminal.results || []);
        })
        .catch(handleListError);
    };

    const invokeListApi = (apiPromise) => {
      if (!apiPromise) {
        handleListError();
        return;
      }
      apiPromise.then(parseFetchListResponse).catch(handleListError);
    };

    const cityIdVal =
      user?.role === "12" ? selectedCity : (user?.cityId ?? cityId);

    const invokeGraphListApi = () => {
      if (report_type === "more_than_two_plus_list") {
        if (user?.role === "2") {
          return twoPlusAction.get2plusNewArophiPreventiveActionPoliceStationList(
            {
              ...request,
              cityId: cityIdVal,
              district: user.districtId,
            },
          );
        }
        return twoPlusAction.get2plusNewArophiPreventiveActionList({
          ...request,
          cityId: cityIdVal,
        });
      }

      if (user?.role === "2") {
        return twoPlusAction.get2plusNewArophiListPoliceStation({
          ...request,
          id: user.districtId,
        });
      }

      if (report_type === "arophi_new_list") {
        if (filter === "by_id") {
          return twoPlusAction.get2lusArophiPostBharaliList({
            ...request,
            cityId: cityIdVal,
          });
        }
        return twoPlusAction.get2lusArophiListCount({
          ...request,
          cityId: cityIdVal,
        });
      }

      if (filter === "by_id") {
        return twoPlusAction.get2PlusNewAropiPostBharaliList({
          ...request,
          cityId: cityIdVal,
        });
      }

      return twoPlusAction.get2PlusNewArophiList({
        ...request,
        cityId: cityIdVal,
      });
    };

    if (user?.role === "9" || user?.role === "10") {
      const mappedDistrictIds = parseMappedDistrictIds(user?.map_districtId);
      const roleDistrictIds = (
        segment.districtId ? [segment.districtId] : mappedDistrictIds
      )
        .map((id) => Number(id))
        .filter((id) => Number.isFinite(id));
      const roleRequest = {
        ...request,
        districtId: roleDistrictIds,
      };

      if (report_type === "more_than_two_plus_list") {
        invokeListApi(
          twoPlusAction.get2plusNewArophiPreventiveActionList({
            ...request,
            cityId: cityIdVal,
          }),
        );
        return;
      }

      if (report_type === "arophi_new_list") {
        invokeListApi(
          filter === "by_id"
            ? twoPlusAction.get2lusArophiPostBharaliListByRole(roleRequest)
            : twoPlusAction.get2lusArophiListCountByRole(roleRequest),
        );
        return;
      }

      invokeListApi(
        filter === "by_id"
          ? twoPlusAction.get2PlusNewAropiPostBharaliListByRole(roleRequest)
          : twoPlusAction.getPlus2ArophiListByRole(roleRequest),
      );
      return;
    }

    invokeListApi(invokeGraphListApi());
  };

  const handleGraphCrimeClick = (data) => {
    const segment = data?.payload?.payload || data?.payload || data;
    if (!segment?.name || segment.name === "Others") return;
    fetchGraphCrimeDetails(segment);
  };

  const handleViewForm = (data) => {
    onViewAccusedForm(data);
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInputRef}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => {
          if (searchInputRef.current) {
            searchInputRef.current.focus();
          }
        }, 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const columnHeader1 = (label, total) => (
    <div style={{ textAlign: "center" }}>
      <div>{label}</div>
      <div style={{ fontSize: 12, color: "rgb(155, 0, 0)", fontWeight: 600 }}>
        (एकूण - {total})
      </div>
    </div>
  );
  const columnTotals1 = newArophiData.reduce(
    (acc, row) => {
      acc["शरीराविषयक"] += Number(row["शरीराविषयक"] || 0);
      acc["मालाविषयक"] += Number(row["मालाविषयक"] || 0);
      acc["अवैध वाळू विषयक"] += Number(row["अवैध वाळू विषयक"] || 0);
      acc["अवैध दारु विषयक"] += Number(row["अवैध दारु विषयक"] || 0);
      acc["जुगारविषयक"] += Number(row["जुगारविषयक"] || 0);
      acc["भाग - ६"] += Number(row["भाग - ६"] || 0);
      acc["इतर"] += Number(row["इतर"] || 0);
      acc["एकुण"] = parseInt(
        acc["शरीराविषयक"] +
          acc["मालाविषयक"] +
          acc["अवैध वाळू विषयक"] +
          acc["जुगारविषयक"] +
          acc["अवैध दारु विषयक"] +
          acc["भाग - ६"] +
          acc["इतर"] || 0,
      );

      return acc;
    },
    {
      शरीराविषयक: 0,
      मालाविषयक: 0,
      "अवैध वाळू विषयक": 0,
      "अवैध दारु विषयक": 0,
      "भाग - ६": 0,
      जुगारविषयक: 0,
      इतर: 0,
      एकुण: 0,
    },
  );
  const data = {
    columns: [
      {
        title: t("sr.no"),
        dataIndex: "srNo",
        key: "srNo",
      },
      {
        title: t("crime_police_station"),
        dataIndex: "districtName",
        key: "districtName",
      },
      {
        title: columnHeader1(t("body_offender"), columnTotals1.शरीराविषयक),

        dataIndex: "शरीराविषयक",
        key: "शरीराविषयक",
        width: "100px",
        render: (text, record) => (
          <Button
            type="primary"
            shape="circle"
            size="small"
            style={{
              width: 36,
              height: 36,
              fontWeight: 600,
              boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
            }}
          >
            {text}
          </Button>
        ),
      },
      {
        title: columnHeader1(t("property_offender"), columnTotals1.मालाविषयक),
        dataIndex: "मालाविषयक",
        key: "मालाविषयक",
        render: (text, record) => (
          <Button
            type="primary"
            shape="circle"
            size="small"
            style={{
              width: 36,
              height: 36,
              fontWeight: 600,
              boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
            }}
          >
            {text}
          </Button>
        ),
      },
      {
        title: columnHeader1(
          t("illegal_sand_transportation"),
          columnTotals1["अवैध वाळू विषयक"],
        ),
        dataIndex: "अवैध वाळू विषयक",
        key: "अवैध वाळू विषयक",
        render: (text, record) => (
          <Button
            type="primary"
            shape="circle"
            size="small"
            style={{
              width: 36,
              height: 36,
              fontWeight: 600,
              boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
              color:"#000"
            }}
          >
            {text}
          </Button>
        ),
      },
      {
        title: columnHeader1(
          t("illegal_liquor_related"),
          columnTotals1["अवैध दारु विषयक"],
        ),
        dataIndex: "अवैध दारु विषयक",
        key: "अवैध दारु विषयक",
        render: (text, record) => (
          <Button
            type="primary"
            shape="circle"
            size="small"
            style={{
              width: 36,
              height: 36,
              fontWeight: 600,
              boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
            }}
          >
            {text}
          </Button>
        ),
      },
      {
        title: columnHeader1(t("gambling_related"), columnTotals1.जुगारविषयक),
        dataIndex: "जुगारविषयक",
        key: "जुगारविषयक",
        render: (text, record) => (
          <Button
            type="primary"
            shape="circle"
            size="small"
            style={{
              width: 36,
              height: 36,
              fontWeight: 600,
              boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
            }}
          >
            {text}
          </Button>
        ),
      },
      {
        title: columnHeader1(t("section_6"), columnTotals1["भाग - ६"]),
        dataIndex: "भाग - ६",
        key: "भाग - ६",
        render: (text, record) => (
          <Button
            type="primary"
            shape="circle"
            size="small"
            style={{
              width: 36,
              height: 36,
              fontWeight: 600,
              boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
            }}
          >
            {text}
          </Button>
        ),
      },
      {
        title: columnHeader1(t("other_crimes"), columnTotals1.इतर),
        dataIndex: "इतर",
        key: "इतर",
        render: (text, record) => (
          <Button
            type="primary"
            shape="circle"
            size="small"
            style={{
              width: 36,
              height: 36,
              fontWeight: 600,
              boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
            }}
          >
            {text}
          </Button>
        ),
      },
      {
        title: columnHeader1(t("total"), columnTotals1.एकुण),
        dataIndex: "एकुण",
        key: "एकुण",
        render: (text, record) => (
          <Button
            type="primary"
            shape="circle"
            size="small"
            style={{
              width: 36,
              height: 36,
              fontWeight: 600,
              boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
            }}
          >
            {text}
          </Button>
        ),
      },
    ],

    rows: newArophiData.map((arophi, index) => ({
      key: index,
      srNo: index + 1,
      districtName: arophi.districtName,
      शरीराविषयक: arophi.शरीराविषयक ? arophi.शरीराविषयक : "0",
      मालाविषयक: arophi?.मालाविषयक ? arophi?.मालाविषयक : "0",
      "अवैध वाळू विषयक": arophi["अवैध वाळू विषयक"]
        ? arophi["अवैध वाळू विषयक"]
        : "0",
      "अवैध दारु विषयक": arophi["अवैध दारु विषयक"]
        ? arophi["अवैध दारु विषयक"]
        : "0",
      जुगारविषयक: arophi.जुगारविषयक ? arophi.जुगारविषयक : "0",
      "भाग - ६": arophi["भाग - ६"] ? arophi?.["भाग - ६"] : "",
      इतर: arophi.इतर ? arophi.इतर : "0",
      एकुण: parseInt(
        arophi?.शरीराविषयक +
          arophi?.मालाविषयक +
          arophi?.["अवैध वाळू विषयक"] +
          arophi?.["अवैध दारु विषयक"] +
          arophi?.जुगारविषयक +
          arophi?.["भाग - ६"] +
          arophi?.इतर,
      ),
    })),
  };

  const columnTotals = arophiCount.reduce(
    (acc, row) => {
      acc.crimeCount += Number(row.crimeCount || 0);
      return acc;
    },
    {
      crimeCount: 0,
    },
  );
  const columnHeader = (label, total) => (
    <div style={{ textAlign: "center" }}>
      <div>{label}</div>
      <div style={{ fontSize: 12, color: "rgb(155, 0, 0)", fontWeight: 600 }}>
        (एकूण - {total})
      </div>
    </div>
  );

  const isAdminGraphBarChart = ["4", "9", "10", "12"].includes(user?.role);

  const preventiveActionPieData = useMemo(() => {
    const totals = PREVENTIVE_ACTION_COLUMNS.reduce((acc, col) => {
      acc[col] = 0;
      return acc;
    }, {});

    (preventiveGraphData || []).forEach((row) => {
      PREVENTIVE_ACTION_COLUMNS.forEach((col) => {
        totals[col] += Number(row[col] || 0);
      });
    });

    const list = Object.entries(totals)
      .map(([name, value]) => ({
        name,
        value,
        preventiveActionId: getPreventiveActionIdByName(name),
      }))
      .filter((x) => x.value > 0)
      .sort((a, b) => b.value - a.value);

    if (list.length === 0) return [];

    const TOP_N = 8;
    const top = list.slice(0, TOP_N);
    const rest = list.slice(TOP_N);
    const restSum = rest.reduce((sum, x) => sum + x.value, 0);

    return restSum > 0
      ? [...top, { name: "Others", value: restSum, othersItems: rest }]
      : top;
  }, [preventiveGraphData]);

  const preventiveGraphTotal = useMemo(
    () => preventiveActionPieData.reduce((sum, x) => sum + x.value, 0),
    [preventiveActionPieData],
  );

  const preventiveActionTableData = useMemo(() => {
    const totals = PREVENTIVE_ACTION_COLUMNS.reduce((acc, col) => {
      acc[col] = 0;
      return acc;
    }, {});

    (preventiveGraphData || []).forEach((row) => {
      PREVENTIVE_ACTION_COLUMNS.forEach((col) => {
        totals[col] += Number(row[col] || 0);
      });
    });

    return Object.entries(totals)
      .map(([name, count], index) => ({ key: index, name, count }))
      .filter((x) => x.count > 0)
      .sort((a, b) => b.count - a.count);
  }, [preventiveGraphData]);

  const policeWisePreventiveBarData = useMemo(() => {
    const rows = (preventiveGraphData || [])
      .map((row, idx) => {
        const count = PREVENTIVE_ACTION_COLUMNS.reduce(
          (sum, col) => sum + Number(row[col] || 0),
          0,
        );
        const name = row.districtName || "-";
        return {
          key: idx,
          name,
          shortName: name.length > 16 ? `${name.slice(0, 14)}…` : name,
          count,
          fill: PIE_COLORS[idx % PIE_COLORS.length],
        };
      })
      .filter((x) => x.count > 0)
      .sort((a, b) => b.count - a.count);

    return rows;
  }, [preventiveGraphData]);

  const policeWisePreventiveBarTotal = useMemo(
    () =>
      policeWisePreventiveBarData.reduce(
        (sum, x) => sum + Number(x.count || 0),
        0,
      ),
    [policeWisePreventiveBarData],
  );

  const crimeHeadBarData = useMemo(
    () =>
      (preventiveGraphData || []).map((row, idx) => ({
        key: row.headingId || row.headingid || idx + 1,
        name: row.name || "-",
        count: Number(row.count || 0),
        headingId: Number(row.headingId ?? row.headingid),
      })),
    [preventiveGraphData],
  );

  const crimeTitleBarData = useMemo(
    () =>
      (preventiveGraphData || []).map((row, idx) => ({
        key: row.typeId || row.typeid || idx + 1,
        name: row.name || "-",
        count: Number(row.count || 0),
        typeId: Number(row.typeId ?? row.typeid),
      })),
    [preventiveGraphData],
  );

  const crimeHeadBarTotal = useMemo(
    () => crimeHeadBarData.reduce((sum, x) => sum + x.count, 0),
    [crimeHeadBarData],
  );

  const crimeTitleBarTotal = useMemo(
    () => crimeTitleBarData.reduce((sum, x) => sum + x.count, 0),
    [crimeTitleBarData],
  );

  const drawerLifetimeCrimesTotal = useMemo(
    () =>
      criminalList.reduce(
        (sum, row) => sum + Number(row.totalCrimeCount || 0),
        0,
      ),
    [criminalList],
  );

  const renderGraphStatBadges = (items) => (
    <div style={styles.graphHeaderTotal}>
      {items.map((item) => {
        const theme =
          GRAPH_STAT_BADGE_THEMES[item.variant] ||
          GRAPH_STAT_BADGE_THEMES.total;
        return (
          <div
            key={item.label}
            style={{
              ...styles.graphStatBadge,
              background: theme.background,
              borderColor: theme.borderColor,
            }}
          >
            <span
              style={{
                ...styles.graphStatBadgeLabel,
                color: theme.labelColor,
              }}
            >
              {item.label}
            </span>
            <span
              style={{
                ...styles.graphStatBadgeValue,
                color: theme.valueColor,
              }}
            >
              {item.value}
            </span>
          </div>
        );
      })}
    </div>
  );

  const renderGraphSectionHeader = (title, subtitle, badgeItems) => (
    <div style={styles.graphSectionHeaderRow}>
      <div style={styles.graphSectionHeaderLeft}>
        <div style={styles.graphSectionTitle}>{title}</div>
        {subtitle && (
          <Text style={styles.graphSectionSubtitle}>{subtitle}</Text>
        )}
      </div>
      {renderGraphStatBadges(badgeItems)}
    </div>
  );

  const renderDateWiseLineChart = () => {
    const activePoint =
      dateWiseActivePoint ||
      dateWiseLineData[dateWiseLineData.length - 1] ||
      null;
    const displayValue = activePoint?.value ?? dateWiseGraphTotal ?? 0;
    const displayDate = activePoint?.label || "";

    return (
      <div style={styles.dateWiseChartWrap}>
        <div style={styles.dateWiseChartHeader}>
          {Number(displayValue).toLocaleString("en-IN")}
          {displayDate ? ` | ${displayDate}` : ""}
        </div>

        <div style={styles.dateWiseChartBody}>
          {dateWiseLineData.length > 0 ? (
            <ResponsiveContainer width="100%" height={300}>
              <LineChart
                data={dateWiseLineData}
                margin={{ top: 12, right: 12, left: 4, bottom: 8 }}
                onMouseMove={(state) => {
                  if (state?.activePayload?.[0]?.payload) {
                    setDateWiseActivePoint(state.activePayload[0].payload);
                  }
                }}
                onMouseLeave={() => {
                  setDateWiseActivePoint(
                    dateWiseLineData[dateWiseLineData.length - 1] || null,
                  );
                }}
              >
                <XAxis dataKey="date" hide />
                <YAxis hide domain={["dataMin - 2", "dataMax + 2"]} />
                {activePoint?.date && (
                  <ReferenceLine
                    x={activePoint.date}
                    stroke="rgba(255,255,255,0.35)"
                    strokeWidth={1}
                  />
                )}
                <RechartsTooltip
                  cursor={{
                    stroke: "rgba(255,255,255,0.35)",
                    strokeWidth: 1,
                  }}
                  content={({ active, payload }) => {
                    if (!active || !payload?.length) return null;
                    const point = payload[0].payload;
                    return (
                      <div
                        style={{
                          background: "#111",
                          border: "1px solid #333",
                          borderRadius: 8,
                          padding: "8px 12px",
                          color: "#fff",
                          fontSize: 13,
                        }}
                      >
                        <div>{point.label}</div>
                        <div style={{ fontWeight: 600, color: "#2dd4bf" }}>
                          {Number(point.value).toLocaleString("en-IN")}
                        </div>
                      </div>
                    );
                  }}
                />
                <Line
                  type="monotone"
                  dataKey="value"
                  stroke="#2dd4bf"
                  strokeWidth={2.5}
                  dot={false}
                  isAnimationActive={false}
                  activeDot={{
                    r: 5,
                    fill: "#2dd4bf",
                    stroke: "#000",
                    strokeWidth: 2,
                  }}
                />
              </LineChart>
            </ResponsiveContainer>
          ) : (
            !dateWiseGraphLoading && (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={
                  <span style={{ color: "#8c8c8c" }}>
                    No २ प्लस data found for the selected period.
                  </span>
                }
              />
            )
          )}
        </div>

        <div style={styles.dateWisePeriodRow}>
          {activeTimeRanges.map((range) => (
            <button
              key={range.key}
              type="button"
              style={{
                ...styles.dateWisePeriodBtn,
                ...(graphTimeRange === range.key
                  ? styles.dateWisePeriodBtnActive
                  : {}),
              }}
              onClick={() => handleGraphTimeRangeClick(range.key)}
            >
              {range.label}
            </button>
          ))}
        </div>
      </div>
    );
  };

  const renderDateWiseCumulativeChart = () => {
    const activePoint =
      dateWiseActivePoint ||
      dateWiseLineData[dateWiseLineData.length - 1] ||
      null;
    const displayValue = activePoint?.value ?? dateWiseGraphTotal ?? 0;
    const displayDate = activePoint?.label || "";
    const displayDaily = activePoint?.daily ?? 0;

    return (
      <div style={styles.dateWiseChartWrap}>
        <div style={styles.dateWiseChartHeader}>
          {Number(displayValue).toLocaleString("en-IN")}
          {displayDate ? ` | ${displayDate}` : ""}
          {displayDaily > 0
            ? ` | +${Number(displayDaily).toLocaleString("en-IN")} ${t("onThisDay")}`
            : ""}
        </div>

        <div style={styles.dateWiseChartBody}>
          {dateWiseLineData.length > 0 ? (
            <ResponsiveContainer width="100%" height={300}>
              <AreaChart
                data={dateWiseLineData}
                margin={{ top: 12, right: 12, left: 4, bottom: 8 }}
                onMouseMove={(state) => {
                  if (state?.activePayload?.[0]?.payload) {
                    setDateWiseActivePoint(state.activePayload[0].payload);
                  }
                }}
                onMouseLeave={() => {
                  setDateWiseActivePoint(
                    dateWiseLineData[dateWiseLineData.length - 1] || null,
                  );
                }}
              >
                <defs>
                  <linearGradient
                    id="cumulativeGradient"
                    x1="0"
                    y1="0"
                    x2="0"
                    y2="1"
                  >
                    <stop offset="0%" stopColor="#2dd4bf" stopOpacity={0.45} />
                    <stop
                      offset="100%"
                      stopColor="#2dd4bf"
                      stopOpacity={0.05}
                    />
                  </linearGradient>
                </defs>
                <XAxis dataKey="date" hide />
                <YAxis hide domain={["dataMin - 2", "dataMax + 2"]} />
                {activePoint?.date && (
                  <ReferenceLine
                    x={activePoint.date}
                    stroke="rgba(255,255,255,0.35)"
                    strokeWidth={1}
                  />
                )}
                <RechartsTooltip
                  cursor={{
                    stroke: "rgba(255,255,255,0.35)",
                    strokeWidth: 1,
                  }}
                  content={({ active, payload }) => {
                    if (!active || !payload?.length) return null;
                    const point = payload[0].payload;
                    return (
                      <div
                        style={{
                          background: "#111",
                          border: "1px solid #333",
                          borderRadius: 8,
                          padding: "8px 12px",
                          color: "#fff",
                          fontSize: 13,
                        }}
                      >
                        <div>{point.label}</div>
                        <div style={{ fontWeight: 600, color: "#2dd4bf" }}>
                          एकूण: {Number(point.value).toLocaleString("en-IN")}
                        </div>
                        <div style={{ color: "#a3a3a3", marginTop: 4 }}>
                          {t("onThisDay")}:{" "}
                          {Number(point.daily ?? 0).toLocaleString("en-IN")}
                        </div>
                      </div>
                    );
                  }}
                />
                <Area
                  type="monotone"
                  dataKey="value"
                  stroke="#2dd4bf"
                  fill="url(#cumulativeGradient)"
                  strokeWidth={2.5}
                  dot={false}
                  isAnimationActive={false}
                  activeDot={{
                    r: 5,
                    fill: "#2dd4bf",
                    stroke: "#000",
                    strokeWidth: 2,
                  }}
                />
              </AreaChart>
            </ResponsiveContainer>
          ) : (
            !dateWiseGraphLoading && (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={
                  <span style={{ color: "#8c8c8c" }}>
                    No २ प्लस cumulative data found for the selected period.
                  </span>
                }
              />
            )
          )}
        </div>

        <div style={styles.dateWisePeriodRow}>
          {activeTimeRanges.map((range) => (
            <button
              key={range.key}
              type="button"
              style={{
                ...styles.dateWisePeriodBtn,
                ...(graphTimeRange === range.key
                  ? styles.dateWisePeriodBtnActive
                  : {}),
              }}
              onClick={() => handleGraphTimeRangeClick(range.key)}
            >
              {range.label}
            </button>
          ))}
        </div>
      </div>
    );
  };

  const renderSampleHorizontalBarChart = (chartData, onBarClick) => {
    const chartTotal = chartData.reduce(
      (sum, item) => sum + Number(item.count || 0),
      0,
    );
    const chartHeight = Math.max(280, chartData.length * 48 + 48);

    return (
      <div
        style={{
          width: "100%",
          height: chartHeight,
          background: "#fff",
          borderRadius: 8,
          border: "1px solid #f0f0f0",
          padding: "12px 8px 4px",
          cursor: onBarClick ? "pointer" : "default",
        }}
      >
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            layout="vertical"
            data={chartData}
            margin={{ top: 8, right: 48, left: 8, bottom: 8 }}
          >
            <CartesianGrid
              strokeDasharray="3 3"
              stroke="#e8e8e8"
              horizontal={false}
            />
            <XAxis
              type="number"
              allowDecimals={false}
              tick={{ fontSize: 12, fill: "#595959" }}
            />
            <YAxis
              type="category"
              dataKey="name"
              width={140}
              tick={{ fontSize: 11, fill: "#595959" }}
            />
            <RechartsTooltip
              cursor={{ fill: "rgba(29, 57, 196, 0.06)" }}
              content={({ active, payload }) => {
                if (!active || !payload?.length) return null;
                const item = payload[0].payload;
                const pct =
                  chartTotal > 0
                    ? ((item.count / chartTotal) * 100).toFixed(1)
                    : 0;
                return (
                  <div
                    style={{
                      background: "#fff",
                      border: "1px solid #e8e8e8",
                      borderRadius: 8,
                      padding: "10px 14px",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                      maxWidth: 300,
                    }}
                  >
                    <div
                      style={{
                        fontWeight: 600,
                        marginBottom: 4,
                        color: "#1d39c4",
                      }}
                    >
                      {item.name}
                    </div>
                    <div style={{ fontSize: 13 }}>
                      {t("total")}: <strong>{item.count}</strong> ({pct}%)
                    </div>
                  </div>
                );
              }}
            />
            <Bar
              dataKey="count"
              radius={[0, 6, 6, 0]}
              maxBarSize={28}
              cursor={onBarClick ? "pointer" : "default"}
              onClick={(barData) => onBarClick?.(barData)}
            >
              {chartData.map((entry, idx) => (
                <Cell
                  key={entry.key}
                  fill={PIE_COLORS[idx % PIE_COLORS.length]}
                />
              ))}
              <LabelList
                dataKey="count"
                position="right"
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                  fill: "#262626",
                }}
              />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    );
  };

  const renderPreventivePieLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    value,
    percent,
  }) => {
    if (percent < 0.04) return null;
    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) * 0.55;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    return (
      <text
        x={x}
        y={y}
        fill="#fff"
        textAnchor="middle"
        dominantBaseline="central"
        fontSize={13}
        fontWeight={700}
      >
        {value}
      </text>
    );
  };

  const preventivePieTooltip = ({ active, payload }) => {
    if (!active || !payload?.length) return null;
    const { name, value, payload: item } = payload[0];
    const pct =
      preventiveGraphTotal > 0
        ? ((value / preventiveGraphTotal) * 100).toFixed(1)
        : 0;
    const othersItems = item?.othersItems || [];

    return (
      <div
        style={{
          background: "#fff",
          border: "1px solid #e8e8e8",
          borderRadius: 8,
          padding: "10px 14px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
          maxWidth: 320,
        }}
      >
        <div style={{ fontWeight: 600, marginBottom: 4, color: "#1d39c4" }}>
          {name}
        </div>
        <div style={{ fontSize: 13, color: "#595959" }}>
          {t("total")}: <strong>{value}</strong> ({pct}%)
        </div>
        {name === "Others" && othersItems.length > 0 && (
          <div
            style={{
              marginTop: 10,
              paddingTop: 8,
              borderTop: "1px solid #f0f0f0",
              maxHeight: 200,
              overflowY: "auto",
            }}
          >
            {othersItems.map((action) => {
              const actionPct =
                preventiveGraphTotal > 0
                  ? ((action.value / preventiveGraphTotal) * 100).toFixed(1)
                  : 0;
              return (
                <div
                  key={action.name}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 12,
                    fontSize: 12,
                    color: "#595959",
                    marginBottom: 6,
                  }}
                >
                  <span style={{ flex: 1, lineHeight: 1.4 }}>
                    {action.name}
                  </span>
                  <span style={{ fontWeight: 600, whiteSpace: "nowrap" }}>
                    {action.value} ({actionPct}%)
                  </span>
                </div>
              );
            })}
          </div>
        )}
        {item?.fill && (
          <div
            style={{
              marginTop: 6,
              height: 4,
              borderRadius: 2,
              background: item.fill,
            }}
          />
        )}
      </div>
    );
  };

  const renderOthersLegendTooltip = (othersItems) => (
    <div style={{ maxWidth: 280 }}>
      {othersItems.map((action) => (
        <div
          key={action.name}
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: 10,
            marginBottom: 4,
            fontSize: 12,
          }}
        >
          <span>{action.name}</span>
          <strong>{action.value}</strong>
        </div>
      ))}
    </div>
  );

  const data_arophi_count = {
    columns: [
      {
        title: t("sr.no"),
        dataIndex: "srNo",
        key: "srNo",
      },
      {
        title:
          filter === "by_distinct"
            ? t("accused_police_station")
            : t("police_station_of_crime"),
        dataIndex: "districtName",
        key: "districtName",
      },
      {
        title: columnHeader(t("2_plus_statistics"), columnTotals.crimeCount),

        dataIndex: "crimeCount",
        key: "crimeCount",
        sorter: (a, b) => a.numericCrimeCount - b.numericCrimeCount,
      },
    ],

    rows: arophiCount.map((arophi, index) => ({
      key: index,
      srNo: index + 1,
      districtName: arophi?.districtName,
      numericCrimeCount: arophi?.crimeCount,
      crimeCount: (
        <Button
          type="primary"
          shape="circle"
          size="small"
          style={{
            width: 36,
            height: 36,
            fontWeight: 600,
            boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
          }}
          disabled={arophi?.crimeCount === 0}
          onClick={() => {
            user.role === "9" || user.role === "10"
              ? showpreventiveDrawer(
                  arophi?.districtId ? arophi?.districtId : arophi?.district,
                )
              : showpreventiveDrawer(
                  filter === "by_distinct"
                    ? arophi?.district
                    : arophi?.district,
                );
            setInfo(arophi);
          }}
        >
          {arophi?.crimeCount}
        </Button>
      ),
    })),
  };

  const [imageOpen, setImageOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [photoFilterStatus, setPhotoFilterStatus] = useState(undefined);
  const [id, setId] = useState();

  const openImageModal = (img, id) => {
    setImageOpen(true);
    setSelectedImage(img);
    setId(id);
  };

  const closeImageModal = () => {
    setImageOpen(false);
    setSelectedImage(null);
  };

  const dataList = {
    columns: [
      {
        title: t("sr.no"),
        dataIndex: "srNo",
        key: "srNo",
      },
      {
        title: "आरोपीचे पो. स्टे",
        dataIndex: "crime_districtName",
        key: "crime_districtName",
        onHeaderCell: () => ({
          style: {
            backgroundColor: "#fff3e0",
            color: "#000",
            fontWeight: "bold",
          },
        }),
        onCell: () => ({
          style: {
            backgroundColor: "#fff3e0",
            color: "#000",
          },
        }),
      },
      {
        title: t("name"),
        dataIndex: "नाव",
        key: "नाव",
        onHeaderCell: () => ({
          style: {
            backgroundColor: "#fff3e0",
            color: "#000",
            fontWeight: "bold",
          },
        }),
        onCell: () => ({
          style: {
            backgroundColor: "#fff3e0",
            color: "#000",
          },
        }),
        render: (text) => <div>{text}</div>,
      },
      {
        title: t("total_crimes"),
        key: "totalCrimeCount",
        dataIndex: "totalCrimeCount",
        sorter: {
          compare: (a, b) => a.totalCrimeCount - b.totalCrimeCount,
        },
        onHeaderCell: () => ({
          style: {
            backgroundColor: "#fff3e0",
            color: "#000",
            fontWeight: "bold",
          },
        }),
        onCell: () => ({
          style: {
            backgroundColor: "#fff3e0",
            color: "#000",
          },
        }),
        render: (text, record) => (
          <div>
            <Button
              type="primary"
              shape="circle"
              size="small"
              style={{
                width: 36,
                height: 36,
                fontWeight: 600,
                boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
              }}
              onClick={() => onGunaForm(record.masterId)}
            >
              {record.totalCrimeCount}
            </Button>
          </div>
        ),
      },
      {
        title: "शेवटच्या गुन्ह्याचे पो. स्टे",
        dataIndex: "last_districtName",
        key: "last_districtName",
        sorter: (a, b) =>
          String(a.last_districtName || "").localeCompare(
            String(b.last_districtName || ""),
            undefined,
            { sensitivity: "base" },
          ),
        onHeaderCell: () => ({
          style: {
            backgroundColor: "#ffcc80",
            color: "#000",
            fontWeight: "bold",
          },
        }),
        onCell: () => ({
          style: {
            backgroundColor: "#ffcc80",
            color: "#000",
          },
        }),
      },
      {
        title: `${t("cr.no")} / ${t("crime_registration_date")}`,
        dataIndex: "cr_no",
        key: "cr_no",
        onHeaderCell: () => ({
          style: {
            backgroundColor: "#ffcc80",
            color: "#000",
            fontWeight: "bold",
          },
        }),
        onCell: () => ({
          style: {
            backgroundColor: "#ffcc80",
            color: "#000",
          },
        }),
        render: (text, record) => {
          const crNo = record.cr_no ? record.cr_no : "-";
          const gunaDate = record.guna_date ? record.guna_date : "-";
          return (
            <div>
              <span style={{ fontWeight: "bold" }}>{crNo}</span>
              <span> - </span>
              <span>{gunaDate}</span>
            </div>
          );
        },
      },
    ],

    rows: arophiList.map((arophi, index) => ({
      key: index,
      srNo: index + 1,
      नाव: <p title={arophi?.id}>{arophi.name ? arophi.name : "-"}</p>,
      last_districtName: arophi.last_districtName || "-",
      crime_districtName: arophi.crime_districtName || "-",
      totalCrimeCount: arophi.totalCrimeCount || "-",
      cr_no: arophi.cr_no || "-",
      guna_date: arophi.guna_date || "-",
      photo: arophi.photo ? arophi.photo : null,
      prevetive_record:
        arophi?.prevetive_records?.length === 0 ? "" : arophi.prevetive_records,
      masterId: arophi.masterId || "-",
    })),
  };

  dataList.columns.push({
    ...{
      title: t("photo"),
      key: "photo",
      // filters: [
      //   {
      //     text: t("photo"), // has photo
      //     value: "has",
      //   },
      //   {
      //     text: t("no"), // no photo
      //     value: "none",
      //   },
      // ],
      onFilter: (value, record) => {
        setPhotoFilterStatus(value);
        if (value === "has") {
          return !!record.photo; // true if photo exists
        }
        if (value === "none") {
          return !record.photo; // true if no photo
        }
        setPhotoFilterStatus(undefined);
        return true;
      },
      onHeaderCell: () => ({
        style: {
          color: "#000",
          fontWeight: "bold",
        },
      }),
      render: (text, record) => ({
        props: { style: { color: "#000" } },
        children: (
          <Space size="middle">
            {record.photo ? (
              <img
                style={{ width: 50, height: 50, cursor: "pointer" }}
                src={
                  "https://pcimageupload.s3.ap-south-1.amazonaws.com/" +
                  record.photo
                }
                onClick={() => openImageModal(record.photo, record.masterId)}
                alt="photo"
              />
            ) : (
              "नाही"
            )}
          </Space>
        ),
      }),
    },
  });
  dataList.columns.push({
    title: t("preventive_action"),
    key: "prevetive_records",
    filters: [
      { text: t("completed"), value: "completed" },
      { text: t("ongoing"), value: "ongoing" },
      { text: t("not_available"), value: "-" },
    ],
    onFilter: (value, record) => {
      const currentDate = moment();

      if (!record.prevetive_record || record.prevetive_record.length === 0) {
        return value === "-";
      }

      const firstRecord = record.prevetive_record[0];
      const dateTo = firstRecord.date_to ? moment(firstRecord.date_to) : null;

      const status = firstRecord.date_to
        ? dateTo.isBefore(currentDate, "day")
          ? "completed"
          : "ongoing"
        : "-";

      return status === value;
    },
    sorter: (a, b) => {
      const currentDate = moment();

      const getStatus = (record) => {
        if (!record.prevetive_record || record.prevetive_record.length === 0) {
          return "-";
        }

        const firstRecord = record.prevetive_record[0];
        const dateTo = firstRecord.date_to ? moment(firstRecord.date_to) : null;

        return firstRecord.date_to
          ? dateTo.isBefore(currentDate, "day")
            ? "completed"
            : "ongoing"
          : "-";
      };

      const statusA = getStatus(a);
      const statusB = getStatus(b);

      // sorting order: completed -> ongoing -> "-"
      const order = { completed: 0, ongoing: 1, "-": 2 };

      return order[statusA] - order[statusB];
    },
    onHeaderCell: () => ({
      style: {
        color: "#000",
        fontWeight: "bold",
      },
    }),

    render: (text, record) => {
      const currentDate = moment();

      if (!record.prevetive_record || record.prevetive_record.length === 0) {
        return {
          props: { style: { color: "#000" } },
          children: <div className="action-links-responsive">-</div>,
        };
      }

      const firstRecord = record.prevetive_record[0];
      const dateTo = firstRecord.date_to ? moment(firstRecord.date_to) : null;

      const status = firstRecord.date_to
        ? dateTo.isBefore(currentDate, "day")
          ? t("completed")
          : t("ongoing")
        : "-";

      return {
        props: { style: { color: "#000" } },
        children: <div className="action-links-responsive">{status}</div>,
      };
    },
  });
  dataList.columns.push({
    ...{
      title: t("action"),
      key: "action",
      onHeaderCell: () => ({
        style: {
          color: "#000",
          fontWeight: "bold",
        },
      }),
      render: (text, record) => ({
        props: { style: { color: "#000" } },
        children: (
          <div className="action-links-responsive">
            <Button
              type="text"
              size="small"
              className="action-link update-link"
              onClick={() => {
                handleViewForm(record?.masterId);
              }}
            >
              {t("view1")}
            </Button>
          </div>
        ),
      }),
    },
  });

  console.log("datalist", dataList);
  const dataListCount = {
    columns: [
      {
        title: t("sr.no"),
        dataIndex: "srNo",
        key: "srNo",
      },
      {
        title: "आरोपीचे पो. स्टे ",
        dataIndex: "crime_districtName",
        key: "crime_districtName",
        onHeaderCell: () => ({
          style: {
            backgroundColor: "#fff3e0",
            color: "#000",
            fontWeight: "bold",
          },
        }),

        // Style the cells
        render: (text) => ({
          props: { style: { backgroundColor: "#fff3e0", color: "#000" } },
          children: <div>{text}</div>,
        }),
      },
      {
        title: t("name"),
        dataIndex: "नाव",
        key: "नाव",
        onHeaderCell: () => ({
          style: {
            backgroundColor: "#fff3e0",
            color: "#000",
            fontWeight: "bold",
          },
        }),

        // Style the cells
        render: (text) => ({
          props: { style: { backgroundColor: "#fff3e0", color: "#000" } },
          children: <div>{text}</div>,
        }),
        // ...getColumnSearchProps("नाव"),
        // sorter: (a, b) => a["नाव"].localeCompare(b["नाव"]),
      },
      {
        title: t("total_crimes"),
        key: "totalCrimeCount",
        dataIndex: "totalCrimeCount",
        sorter: {
          compare: (a, b) => a.totalCrimeCount - b.totalCrimeCount,
        },
        onHeaderCell: () => ({
          style: {
            backgroundColor: "#fff3e0",
            color: "#000",
            fontWeight: "bold",
          },
        }),

        render: (text, record) => ({
          props: { style: { backgroundColor: "#fff3e0", color: "#000" } },
          children: (
            <div>
              <Button
                type="primary"
                shape="circle"
                size="small"
                style={{
                  width: 36,
                  height: 36,
                  fontWeight: 600,
                  boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                }}
                onClick={() => {
                  onGunaForm(record.masterId);
                }}
              >
                {record.totalCrimeCount}
              </Button>
            </div>
          ),
        }),
      },
      {
        title: "शेवटच्या गुन्ह्याचे पो. स्टे",
        dataIndex: "last_districtName",
        key: "last_districtName",
        sorter: (a, b) =>
          String(a.last_districtName || "").localeCompare(
            String(b.last_districtName || ""),
            undefined,
            { sensitivity: "base" },
          ),
        onHeaderCell: () => ({
          style: {
            backgroundColor: "#ffcc80",
            color: "#000",
            fontWeight: "bold",
          },
        }),

        // Style the cells
        render: (text) => ({
          props: { style: { backgroundColor: "#ffcc80", color: "#000" } },
          children: <div>{text}</div>,
        }),
      },

      {
        title: `${t("cr.no")} / ${t("crime_registration_date")}`,
        dataIndex: "cr_no",
        key: "cr_no",
        onHeaderCell: () => ({
          style: {
            backgroundColor: "#ffcc80",
            color: "#000",
            fontWeight: "bold",
          },
        }),
        onCell: () => ({
          style: {
            backgroundColor: "#ffcc80",
            color: "#000",
          },
        }),
        render: (text, record) => {
          const crNo = record.cr_no ? record.cr_no : "-";
          const gunaDate = record.guna_date ? record.guna_date : "-";
          return (
            <div>
              <span style={{ fontWeight: "bold" }}>{crNo}</span>
              <span> - </span>
              <span>{gunaDate}</span>
            </div>
          );
        },
      },
    ],

    rows: arophiListCount.map((arophi, index) => ({
      key: index,
      srNo: index + 1,
      नाव: <p title={arophi?.id}>{arophi.name ? arophi.name : "-"}</p>,
      last_districtName: arophi.last_districtName,
      crime_districtName: arophi.crime_districtName
        ? arophi.crime_districtName
        : "-",
      totalCrimeCount: arophi.totalCrimeCount ? arophi.totalCrimeCount : "-",
      cr_no: arophi.cr_no || "-",
      guna_date: arophi.guna_date || "-",
      photo: arophi.photo ? arophi.photo : null,
      prevetive_record:
        arophi?.prevetive_records?.length == 0 ? "" : arophi.prevetive_records,
      masterId: arophi.masterId ? arophi.masterId : "-",
    })),
  };
  dataListCount.columns.push({
    ...{
      title: t("photo"),
      key: "photo",
      // filters: [
      //   {
      //     text: t("photo"), // has photo
      //     value: "has",
      //   },
      //   {
      //     text: t("no"), // no photo
      //     value: "none",
      //   },
      // ],
      onFilter: (value, record) => {
        setPhotoFilterStatus(value);
        if (value === "has") {
          return !!record.photo; // true if photo exists
        }
        if (value === "none") {
          return !record.photo; // true if no photo
        }
        setPhotoFilterStatus(undefined);
        return true;
      },
      onHeaderCell: () => ({
        style: {
          color: "#000",
          fontWeight: "bold",
        },
      }),
      render: (text, record) => ({
        props: { style: { color: "#000" } },
        children: (
          <Space size="middle">
            {record.photo ? (
              <img
                style={{ width: 50, height: 50, cursor: "pointer" }}
                src={
                  "https://pcimageupload.s3.ap-south-1.amazonaws.com/" +
                  record.photo
                }
                onClick={() => openImageModal(record.photo, record.masterId)}
                alt="photo"
              />
            ) : (
              "नाही"
            )}
          </Space>
        ),
      }),
    },
  });
  dataListCount.columns.push({
    title: t("preventive_action"),
    key: "prevetive_records",
    filters: [
      { text: t("completed"), value: "completed" },
      { text: t("ongoing"), value: "ongoing" },
      { text: t("not_available"), value: "-" },
    ],
    onFilter: (value, record) => {
      const currentDate = moment();

      if (!record.prevetive_record || record.prevetive_record.length === 0) {
        return value === "-";
      }

      const firstRecord = record.prevetive_record[0];
      const dateTo = firstRecord.date_to ? moment(firstRecord.date_to) : null;

      const status = firstRecord.date_to
        ? dateTo.isBefore(currentDate, "day")
          ? "completed"
          : "ongoing"
        : "-";

      return status === value;
    },
    sorter: (a, b) => {
      const currentDate = moment();

      const getStatus = (record) => {
        if (!record.prevetive_record || record.prevetive_record.length === 0) {
          return "-";
        }

        const firstRecord = record.prevetive_record[0];
        const dateTo = firstRecord.date_to ? moment(firstRecord.date_to) : null;

        return firstRecord.date_to
          ? dateTo.isBefore(currentDate, "day")
            ? "completed"
            : "ongoing"
          : "-";
      };

      const statusA = getStatus(a);
      const statusB = getStatus(b);

      // sorting order: completed -> ongoing -> "-"
      const order = { completed: 0, ongoing: 1, "-": 2 };

      return order[statusA] - order[statusB];
    },
    onHeaderCell: () => ({
      style: {
        color: "#000",
        fontWeight: "bold",
      },
    }),

    render: (text, record) => {
      const currentDate = moment();

      if (!record.prevetive_record || record.prevetive_record.length === 0) {
        return {
          props: { style: { color: "#000" } },
          children: <div className="action-links-responsive">-</div>,
        };
      }

      const firstRecord = record.prevetive_record[0];
      const dateTo = firstRecord.date_to ? moment(firstRecord.date_to) : null;

      const status = firstRecord.date_to
        ? dateTo.isBefore(currentDate, "day")
          ? t("completed")
          : t("ongoing")
        : "-";

      return {
        props: { style: { color: "#000" } },
        children: <div className="action-links-responsive">{status}</div>,
      };
    },
  });
  dataListCount.columns.push({
    ...{
      title: t("action"),
      key: "action",
      onHeaderCell: () => ({
        style: {
          color: "#000",
          fontWeight: "bold",
        },
      }),
      render: (text, record) => ({
        props: { style: { color: "#000" } },
        children: (
          <div className="action-links-responsive">
            <Button
              type="text"
              size="small"
              className="action-link update-link"
              onClick={() => {
                handleViewForm(record?.masterId);
              }}
            >
              {t("view1")}
            </Button>
          </div>
        ),
      }),
    },
  });

  const data_history_count = {
    columns: [
      {
        title: t("sr.no"),
        dataIndex: "srNo",
        key: "srNo",
      },
      {
        title: t("accused_police_station"),
        dataIndex: "districtName",
        key: "districtName",
      },
      {
        title: t("history_sheeter_statistics"),
        dataIndex: "crimeCount",
        key: "crimeCount",
      },
    ],

    rows: historyCount.map((arophi, index) => ({
      key: index,
      srNo: index + 1,
      districtName: arophi?.districtName,
      crimeCount: (
        <Button
          style={{
            marginBottom: "5px",
            border: "none",
            backgroundColor: "#86cff2",
            color: "black",
          }}
          onClick={() => {
            user.role === "9" || user.role === "10"
              ? showhistoryPreventiveDrawer(arophi?.district)
              : showhistoryPreventiveDrawer(arophi?.districtName);
          }}
        >
          {arophi?.Count_district}
        </Button>
      ),
    })),
  };

  const dataHistoryList = {
    columns: [
      {
        title: t("sr.no"),
        dataIndex: "srNo",
        key: "srNo",
      },
      {
        title: t("name"),
        dataIndex: "नाव",
        key: "नाव",
        // ...(user?.role !== "2" ? getColumnSearchProps("नाव") : {}),
      },
      {
        title: t("age"),
        dataIndex: "वय",
        key: "वय",
      },
      {
        title: t("accused_police_station"),
        dataIndex: "आरोपीचे पोलिस ठाणे",
        key: "आरोपीचे पोलिस ठाणे",
        sorter: (a, b) =>
          a["आरोपीचे पोलिस ठाणे"].localeCompare(b["आरोपीचे पोलिस ठाणे"]),
        // ...(user?.role !== "2"
        //   ? {
        //       sorter: (a, b) =>
        //         a["आरोपीचे पोलिस ठाणे"].localeCompare(b["आरोपीचे पोलिस ठाणे"]),
        //     }
        //   : {}),
      },
      {
        title: t("total_crimes"),
        key: "totalCrimeCount",
        sorter: {
          compare: (a, b) => a.totalCrimeCount - b.totalCrimeCount,
        },
        dataIndex: "totalCrimeCount",
        // ...(user?.role !== "2"
        //   ? {
        //       sorter: (a, b) => a["totalCrimeCount"] - b["totalCrimeCount"],
        //     }
        //   : {}),
        render: (text, record) => (
          <div>
            <Button
              type="primary"
              shape="circle"
              size="small"
              style={{
                width: 36,
                height: 36,
                fontWeight: 600,
                boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
              }}
              onClick={() => {
                onGunaForm(record.id);
              }}
            >
              {record.totalCrimeCount}
            </Button>
          </div>
        ),
      },
    ],

    rows: historyList.map((arophi, index) => ({
      key: index,
      srNo: index + 1,
      districtName: arophi.districtName,
      "आरोपीचे पोलिस ठाणे": arophi.districtName ? arophi.districtName : "-",
      वय: arophi?.age ? arophi?.age : "-",
      नाव: <p title={arophi?.id}>{arophi.name ? arophi.name : "-"}</p>,
      totalCrimeCount: arophi.totalCrimeCount ? arophi.totalCrimeCount : "-",
      photo: arophi.photos ? arophi.photos : null,
      prevetive_record:
        arophi?.prevetive_records?.length == 0 ? "" : arophi.prevetive_records,
      id: arophi.id ? arophi.id : "",
    })),
  };
  dataHistoryList.columns.push({
    ...{
      title: t("photo"),
      key: "photo",
      // filters: [
      //   {
      //     text: t("photo"), // has photo
      //     value: "has",
      //   },
      //   {
      //     text: t("no"), // no photo
      //     value: "none",
      //   },
      // ],
      onFilter: (value, record) => {
        setPhotoFilterStatus(value);
        if (value === "has") {
          return !!record.photo; // true if photo exists
        }
        if (value === "none") {
          return !record.photo; // true if no photo
        }
        setPhotoFilterStatus(undefined);
        return true;
      },
      render: (text, record) => (
        <Space size="middle">
          {record.photo ? (
            <img
              style={{ width: 50, height: 50 }}
              src={
                "https://pcimageupload.s3.ap-south-1.amazonaws.com/" +
                record.photo
              }
              onClick={() => openImageModal(record.photo, record.masterId)}
            ></img>
          ) : (
            t("no")
          )}
        </Space>
      ),
    },
  });
  console.log("list", dataHistoryList.rows);
  // Column 1 → Preventive Action (status)
  dataHistoryList.columns.push({
    title: t("preventive_action"),
    key: "prevetive_records",
    filters: [
      { text: t("completed"), value: "completed" },
      { text: t("ongoing"), value: "ongoing" },
      { text: t("not_available"), value: "-" },
    ],
    onFilter: (value, record) => {
      const currentDate = moment();

      if (!record.prevetive_record || record.prevetive_record.length === 0) {
        return value === "-";
      }

      const firstRecord = record.prevetive_record[0];
      const dateTo = firstRecord.date_to ? moment(firstRecord.date_to) : null;

      const status = firstRecord.date_to
        ? dateTo.isBefore(currentDate, "day")
          ? "completed"
          : "ongoing"
        : "-";

      return status === value;
    },
    sorter: (a, b) => {
      const currentDate = moment();

      const getStatus = (record) => {
        if (!record.prevetive_record || record.prevetive_record.length === 0) {
          return "-";
        }

        const firstRecord = record.prevetive_record[0];
        const dateTo = firstRecord.date_to ? moment(firstRecord.date_to) : null;

        return firstRecord.date_to
          ? dateTo.isBefore(currentDate, "day")
            ? "completed"
            : "ongoing"
          : "-";
      };

      const statusA = getStatus(a);
      const statusB = getStatus(b);

      // sorting order: completed -> ongoing -> "-"
      const order = { completed: 0, ongoing: 1, "-": 2 };

      return order[statusA] - order[statusB];
    },
    render: (text, record) => {
      const currentDate = moment();

      if (!record.prevetive_record || record.prevetive_record.length === 0) {
        return <div className="action-links-responsive">-</div>;
      }

      const firstRecord = record.prevetive_record[0];
      const dateTo = firstRecord.date_to ? moment(firstRecord.date_to) : null;

      const status = firstRecord.date_to
        ? dateTo.isBefore(currentDate, "day")
          ? t("completed")
          : t("ongoing")
        : "-";

      return (
        <div className="action-links-responsive">
          <Button
            type="text"
            size="small"
            className="action-link update-link"
            disabled={status === "-"}
            onClick={() => onpreventiveForm(record.id)}
          >
            {status}
          </Button>
        </div>
      );
    },
  });

  // Column 2 → Action (button)
  dataHistoryList.columns.push({
    title: t("action"),
    key: "action",
    render: (text, record) => (
      <div className="action-links-responsive">
        <Button
          type="text"
          size="small"
          className="action-link update-link"
          onClick={() => handleViewForm(record.id)}
        >
          {t("view1")}
        </Button>
      </div>
    ),
  });

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const handleTableChange = (pagination, filters, sorter, extra) => {
    setPagination({
      ...pagination,
      pageSize: pagination.pageSize,
    });

    if (extra?.action === "filter" && showList === "यादी") {
      const statuses = Array.isArray(filters?.prevetive_records)
        ? filters.prevetive_records
        : [];
      setTablePreventiveFilters(statuses);
      onPreventiveFilterChange?.(statuses);
    }

    if (!onTableSortChange || extra?.action !== "sort") {
      return;
    }

    onTableSortChange({
      field: sorter?.field || sorter?.columnKey || "",
      order: sorter?.order || "",
    });
  };
  console.log("total", total);

  const getPreventiveStatus = (record) => {
    const currentDate = moment();

    if (!record.prevetive_record || record.prevetive_record.length === 0) {
      return "-";
    }

    const firstRecord = record.prevetive_record[0];
    const dateTo = firstRecord.date_to ? moment(firstRecord.date_to) : null;

    return firstRecord.date_to
      ? dateTo.isBefore(currentDate, "day")
        ? "completed"
        : "ongoing"
      : "-";
  };

  const preventiveData =
    report_type === "arophi_new_list"
      ? dataListCount.rows
      : report_type === "more_than_two_plus_list"
        ? dataListCount.rows
        : dataList.rows;

  const completedCount = preventiveData.filter(
    (item) => getPreventiveStatus(item) === "completed",
  ).length;

  const ongoingCount = preventiveData.filter(
    (item) => getPreventiveStatus(item) === "ongoing",
  ).length;

  const dashCount = preventiveData.filter(
    (item) => getPreventiveStatus(item) === "-",
  ).length;

  const totalPreventiveCount = preventiveData.length;
  const menuContent = (
    <div className="gov-notification-panel">
      <div className="notif-header">{t("preventive_action")}</div>

      <div className="notif-item completed">
        <span>कारवाई पूर्ण झाली</span>
        <strong>{completedCount}</strong>
      </div>

      <div className="notif-item ongoing">
        <span>कारवाई चालू आहे</span>
        <strong>{ongoingCount}</strong>
      </div>

      <div className="notif-item dash">
        <span>अद्याप कारवाई केली नाही</span>
        <strong>{dashCount}</strong>
      </div>
    </div>
  );

  // === NEW STATES FOR DISTRICT FILTER ===
  const [selectedDistricts, setSelectedDistricts] = useState([]);

  // Get unique districts from last_districtName
  const availableDistricts = useMemo(() => {
    const list =
      report_type === "arophi_new_list" ||
      report_type === "more_than_two_plus_list"
        ? dataListCount.rows
        : dataList.rows;

    const districts = list
      .map((item) => item.last_districtName)
      .filter((d) => d && d !== "-");

    return [...new Set(districts)].sort();
  }, [dataList.rows, dataListCount.rows, report_type]);

  // Filtered data based on selected districts
  const filteredListData = useMemo(() => {
    let sourceData =
      report_type === "arophi_new_list" ||
      report_type === "more_than_two_plus_list"
        ? dataListCount.rows
        : dataList.rows;

    if (selectedDistricts.length === 0) return sourceData;

    return sourceData.filter((item) =>
      selectedDistricts.includes(item.last_districtName),
    );
  }, [dataListCount.rows, dataList.rows, selectedDistricts, report_type]);

  // Reset filter
  const resetDistrictFilter = () => {
    setSelectedDistricts([]);
    onDistrictFilterChange?.([]);
  };

  const preventiveStatusOf = (item) => {
    const records = item?.prevetive_records?.length
      ? item.prevetive_records
      : item?.prevetive_record?.length
        ? item.prevetive_record
        : [];
    if (!records.length) return "-";
    const firstRecord = records[0];
    if (!firstRecord?.date_to) return "-";
    return moment(firstRecord.date_to).isBefore(moment(), "day")
      ? "completed"
      : "ongoing";
  };

  const listSource = useMemo(() => {
    if (
      report_type === "arophi_new_list" ||
      report_type === "more_than_two_plus_list"
    ) {
      return arophiListCount || [];
    }
    if (report_type === "history_sheeter") {
      return historyList || [];
    }
    return arophiList || [];
  }, [report_type, arophiList, arophiListCount, historyList]);

  const visibleSource = useMemo(() => {
    let rows = listSource;
    if (report_type !== "history_sheeter" && selectedDistricts.length > 0) {
      rows = rows.filter((item) =>
        selectedDistricts.includes(item.last_districtName),
      );
    }
    if (showList === "यादी" && tablePreventiveFilters.length > 0) {
      rows = rows.filter((item) =>
        tablePreventiveFilters.includes(preventiveStatusOf(item)),
      );
    }
    return rows;
  }, [
    listSource,
    report_type,
    selectedDistricts,
    showList,
    tablePreventiveFilters,
  ]);

  const visibleExportIds = useMemo(() => {
    if (showList !== "यादी") return null;
    return visibleSource
      .map((item) => item.masterId ?? item.id)
      .filter((id) => id != null && id !== "-");
  }, [showList, visibleSource]);

  useEffect(() => {
    onVisibleRowsChange?.(visibleExportIds);
  }, [visibleExportIds, onVisibleRowsChange]);

  useEffect(() => {
    setTablePreventiveFilters([]);
    onPreventiveFilterChange?.([]);
  }, [showList, report_type]);

  const filteredPhotoCount = useMemo(() => {
    let count = 0;
    const rows = showList === "यादी" ? visibleSource : filteredListData;

    for (let item of rows) {
      if (item.photo) count++;
    }

    return count;
  }, [showList, visibleSource, filteredListData]);

  const totalCount = useMemo(() => {
    let count = 0;
    const rows = showList === "यादी" ? visibleSource : filteredListData;

    for (let item of rows) {
      if (photoFilterStatus === "has" && item.photo) count++;
      else if (photoFilterStatus === "none" && !item.photo) count++;
      else if (!photoFilterStatus || photoFilterStatus === "all") count++;
    }

    return count;
  }, [showList, visibleSource, filteredListData, photoFilterStatus]);

  return (
    <>
      <div style={styles.pageContainer}>
        {(report_type === "arophi count" ||
          report_type === "history_sheeter" ||
          report_type === "arophi_new_list" ||
          report_type === "more_than_two_plus_list" ||
          report_type === "new arophi") &&
          !graphOnly && (
            <div style={styles.viewTypeSection}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                  flexWrap: "wrap",
                  gap: "12px",
                }}
              >
                {/* LEFT SIDE ITEMS */}
                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    flexWrap: "wrap",
                    alignItems: "center",
                  }}
                >
                  {["4", "9", "10", "12"].includes(user.role) && (
                    <Button
                      type={showList === "सांख्यिकी" ? "primary" : "default"}
                      onClick={() => getShowList("सांख्यिकी")}
                      icon={<BarChartOutlined />}
                      style={styles.actionButton}
                    >
                      {t("statistics1")}
                    </Button>
                  )}

                  {user.role !== "12" && (
                    <Button
                      type={showList === "यादी" ? "primary" : "default"}
                      onClick={() => getShowList("यादी")}
                      icon={<UnorderedListOutlined />}
                      style={styles.actionButton}
                    >
                      {t("list")}
                    </Button>
                  )}

                  <div style={styles.totalCount}>
                    <span style={{ color: "#fff" }}>{t("total")}:</span>
                    <span style={{ color: "#fff", fontWeight: "bold" }}>
                      {showList === "graph"
                        ? preventiveGraphTotal
                        : showList === "सांख्यिकी"
                          ? total
                          : totalCount}
                    </span>
                  </div>

                  {showList === "यादी" && total != 0 && (
                    <div style={styles.totalPhoto}>
                      <span style={{ color: "#fff" }}>
                        {t("total_photo_count")} :
                        <span style={{ fontWeight: "bold" }}>
                          {filteredPhotoCount || "0"}
                        </span>
                      </span>
                    </div>
                  )}
                </div>

                {/* RIGHT SIDE */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    marginLeft: "auto",
                    flexWrap: "wrap",
                  }}
                >
                  {showList === "यादी" && total != 0 && (
                    <>
                      <Select
                        mode="multiple"
                        placeholder="पोलिस स्टेशन"
                        value={selectedDistricts}
                        onChange={(value) => {
                          setSelectedDistricts(value);
                          onDistrictFilterChange?.(value || []);
                        }}
                        style={{ minWidth: 280 }}
                        showSearch
                        allowClear
                        maxTagCount={2}
                      >
                        {availableDistricts.map((district) => (
                          <Option key={district} value={district}>
                            {district}
                          </Option>
                        ))}
                      </Select>

                      <Button onClick={resetDistrictFilter} danger>
                        Reset
                      </Button>
                    </>
                  )}

                  {showGraphToggle &&
                    onToggleGraph &&
                    report_type &&
                    filter &&
                    startDate &&
                    endDate && (
                      <div
                        role="button"
                        tabIndex={0}
                        style={styles.analyticalBadge}
                        onClick={onToggleGraph}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            onToggleGraph();
                          }
                        }}
                      >
                        <BarChartOutlined />
                        <span>{t("analytical")}</span>
                      </div>
                    )}

                  {showList === "यादी" && total != 0 && (
                    <Dropdown
                      dropdownRender={() => menuContent}
                      trigger={["click"]}
                      placement="bottomRight"
                    >
                      <Badge count={completedCount + ongoingCount + dashCount}>
                        <Button
                          icon={<FileTextOutlined />}
                          style={{
                            background: "#f8fafc",
                            border: "1px solid #cbd5e1",
                            fontWeight: 600,
                          }}
                        >
                          {t("current_status")}
                        </Button>
                      </Badge>
                    </Dropdown>
                  )}
                </div>
              </div>
            </div>
          )}
        {/* {report_type === "arophi_new_list" && total !== 0 && (
          <div
            style={{
              padding: "4px 12px",
              background: "#fff",
              borderRadius: "4px",
              border: "1px solid #d9d9d9",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              width: "8%",
              marginBottom: "10px",
            }}
          >
            <span style={{ color: "#666" }}>{t("total")}:</span>
            <span style={{ fontWeight: "bold" }}>{total != 0 && total}</span>
          </div>
        )} */}

        <div style={styles.tableContainer}>
          {showList === "graph" && (
            <Spin
              spinning={
                graphViewType === "date_wise"
                  ? dateWiseGraphLoading
                  : preventiveGraphLoading
              }
            >
              <Card
                bordered={false}
                style={styles.graphCard}
                bodyStyle={{ padding: 0 }}
              >
                <div style={styles.graphPageHeader}>
                  <div>
                    <Title level={4} style={{ margin: 0, color: "#262626" }}>
                      Graph
                    </Title>
                    <Text type="secondary" style={{ fontSize: 13 }}>
                      {graphOnly && graphPeriodLabel
                        ? graphPeriodLabel
                        : startDate && endDate
                          ? `${moment(startDate).format("DD-MM-YYYY")} — ${moment(endDate).format("DD-MM-YYYY")}`
                          : ""}
                    </Text>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    {showGraphToggle && onToggleGraph && (
                      <Tooltip title={t("list")}>
                        <Button
                          size="small"
                          type="primary"
                          icon={<UnorderedListOutlined />}
                          onClick={onToggleGraph}
                        />
                      </Tooltip>
                    )}
                    <Select
                      value={graphViewType}
                      onChange={(value) => setGraphViewType(value)}
                      style={{ minWidth: 220 }}
                      placeholder="Select graph"
                    >
                      <Option value="preventive_action">
                        {t("preventive_action")}
                      </Option>
                      <Option value="shirshak">{t("title")}</Option>
                      <Option value="laghushirshak">{t("sub_title")}</Option>
                      {report_type === "arophi count" && user.role === "4" && (
                        <Option value="date_wise">{t("two_plus")}</Option>
                      )}
                    </Select>
                  </div>
                </div>

                <div style={{ padding: "20px 24px" }}>
                  {graphViewType === "preventive_action" &&
                    (preventiveActionPieData.length > 0 ? (
                      <div style={styles.graphSection}>
                        {renderGraphSectionHeader(
                          t("preventive_action"),
                          `${t("preventive_action")} — Pie`,
                          [
                            {
                              label: t("total"),
                              value: preventiveGraphTotal,
                              variant: "total",
                            },
                            {
                              label: "Actions",
                              value: preventiveActionTableData.length,
                              variant: "actions",
                            },
                          ],
                        )}
                        <div
                          style={{
                            width: "100%",
                            height: 400,
                            position: "relative",
                            background: "#fff",
                            borderRadius: 8,
                            border: "1px solid #f0f0f0",
                            padding: 8,
                          }}
                        >
                          <ResponsiveContainer width="100%" height="100%">
                            <PieChart>
                              <Pie
                                data={preventiveActionPieData}
                                dataKey="value"
                                nameKey="name"
                                cx="50%"
                                cy="50%"
                                innerRadius={65}
                                outerRadius={120}
                                paddingAngle={2}
                                label={renderPreventivePieLabel}
                                labelLine={false}
                                cursor="pointer"
                                onClick={handleGraphCrimeClick}
                              >
                                {preventiveActionPieData.map((entry, idx) => (
                                  <Cell
                                    key={`preventive-cell-${entry.name}-${idx}`}
                                    fill={PIE_COLORS[idx % PIE_COLORS.length]}
                                    stroke="#fff"
                                    strokeWidth={2}
                                  />
                                ))}
                              </Pie>
                              <RechartsTooltip content={preventivePieTooltip} />
                            </PieChart>
                          </ResponsiveContainer>
                        </div>
                      </div>
                    ) : (
                      !preventiveGraphLoading && (
                        <div style={styles.graphSection}>
                          <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description={
                              <span style={{ color: "#8c8c8c" }}>
                                No preventive action data found for the selected
                                date range.
                              </span>
                            }
                          />
                        </div>
                      )
                    ))}

                  {graphViewType === "shirshak" &&
                    (crimeHeadBarData.length > 0 ? (
                      <div style={styles.graphSection}>
                        {renderGraphSectionHeader(
                          t("title"),
                          `${t("crime_heading") || "Crime Head"} — Horizontal Bar`,
                          [
                            {
                              label: t("crime_heading") || "Crime Head",
                              value: crimeHeadBarData.length,
                              variant: "district",
                            },
                            {
                              label: t("total"),
                              value: crimeHeadBarTotal,
                              variant: "total",
                            },
                          ],
                        )}
                        {renderSampleHorizontalBarChart(
                          crimeHeadBarData,
                          handleGraphCrimeClick,
                        )}
                      </div>
                    ) : (
                      !preventiveGraphLoading && (
                        <div style={styles.graphSection}>
                          <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description={
                              <span style={{ color: "#8c8c8c" }}>
                                No शीर्षक data found for the selected date
                                range.
                              </span>
                            }
                          />
                        </div>
                      )
                    ))}

                  {graphViewType === "laghushirshak" &&
                    (crimeTitleBarData.length > 0 ? (
                      <div style={styles.graphSection}>
                        {renderGraphSectionHeader(
                          t("sub_title"),
                          `${t("sub_title")} — Horizontal Bar`,
                          [
                            {
                              label: t("crime_title") || "Crime Title",
                              value: crimeTitleBarData.length,
                              variant: "actions",
                            },
                            {
                              label: t("total"),
                              value: crimeTitleBarTotal,
                              variant: "total",
                            },
                          ],
                        )}
                        {renderSampleHorizontalBarChart(
                          crimeTitleBarData,
                          handleGraphCrimeClick,
                        )}
                      </div>
                    ) : (
                      !preventiveGraphLoading && (
                        <div style={styles.graphSection}>
                          <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description={
                              <span style={{ color: "#8c8c8c" }}>
                                No लघुशीर्षक data found for the selected date
                                range.
                              </span>
                            }
                          />
                        </div>
                      )
                    ))}

                  {graphViewType === "date_wise" && (
                    <>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          flexWrap: "wrap",
                          gap: 12,
                          marginBottom: 16,
                        }}
                      >
                        <Radio.Group
                          onChange={onChangeGraphType}
                          value={graphType}
                        >
                          <Radio value="trend_graph">{t("trendGraph")}</Radio>
                          <Radio value="cummulative_graph">
                            {t("cumulativeGraph")}
                          </Radio>
                        </Radio.Group>
                        <Select
                          value={dateWiseGranularity}
                          onChange={onChangeGranularity}
                          style={{ minWidth: 160 }}
                        >
                          <Option value="day">{t("day_wise")}</Option>
                          {graphType === "cummulative_graph" && (
                            <Option value="month">{t("month_wise")}</Option>
                          )}
                        </Select>
                      </div>
                      {graphType === "trend_graph" && (
                        <div style={styles.graphSection}>
                          {renderGraphSectionHeader(
                            "२ प्लस",
                            dateWiseGranularity === "month"
                              ? t("twoPlusLineChartMonthWise")
                              : t("twoPlusLineChartDayWise"),
                            [
                              {
                                label: t("total"),
                                value: dateWiseGraphTotal,
                                variant: "total",
                              },
                              {
                                label: t("duration"),
                                value: graphTimeRangeLabel,
                                variant: "actions",
                              },
                            ],
                          )}
                          {renderDateWiseLineChart()}
                        </div>
                      )}
                      {graphType === "cummulative_graph" && (
                        <div style={styles.graphSection}>
                          {renderGraphSectionHeader(
                            "२ प्लस",
                            dateWiseGranularity === "month"
                              ? `${t("two_plus")}- ${t("cumulativeGraph")} (${t("month_wise")})`
                              : `${t("two_plus")}- ${t("cumulativeGraph")} (${t("day_wise")})`,
                            [
                              {
                                label: t("total"),
                                value: dateWiseGraphTotal,
                                variant: "total",
                              },
                              {
                                label: "Period",
                                value: graphTimeRangeLabel,
                                variant: "actions",
                              },
                            ],
                          )}
                          {renderDateWiseCumulativeChart()}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </Card>
            </Spin>
          )}

          {report_type === "new arophi" && showList !== "graph" && (
            <Table
              bordered
              loading={loading}
              scroll={{ x: "max-content" }}
              columns={data.columns}
              dataSource={data.rows}
              pagination={{
                current: pagination.current,
                pageSize: pagination.pageSize,
                showSizeChanger: true,
              }}
              onChange={handleTableChange}
              rowClassName={() => "govt-table-row"}
            />
          )}

          {report_type === "arophi count" && showList !== "graph" && (
            <>
              {showList === "सांख्यिकी" ? (
                <>
                  <Table
                    bordered
                    loading={loading}
                    scroll={{ x: "max-content" }}
                    columns={data_arophi_count.columns}
                    dataSource={data_arophi_count.rows}
                    pagination={{
                      current: pagination.current,
                      pageSize: pagination.pageSize,
                      showSizeChanger: true,
                    }}
                    onChange={handleTableChange}
                  />
                </>
              ) : (
                <Table
                  bordered
                  loading={loading}
                  scroll={{ x: "max-content" }}
                  columns={dataList.columns}
                  dataSource={filteredListData}
                  pagination={{
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                    showSizeChanger: true,
                  }}
                  onChange={handleTableChange}
                />
              )}
            </>
          )}

          {(report_type === "arophi_new_list" ||
            report_type === "more_than_two_plus_list") &&
            showList === "यादी" && (
              <>
                <Table
                  bordered
                  loading={loading}
                  scroll={{ x: "max-content" }}
                  columns={dataListCount.columns}
                  dataSource={filteredListData}
                  pagination={{
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                    showSizeChanger: true,
                  }}
                  onChange={handleTableChange}
                />
              </>
            )}

          {(report_type === "arophi_new_list" ||
            report_type === "more_than_two_plus_list") &&
            showList === "सांख्यिकी" && (
              <>
                <Table
                  bordered
                  loading={loading}
                  scroll={{ x: "max-content" }}
                  columns={data_arophi_count.columns}
                  dataSource={data_arophi_count.rows}
                  pagination={{
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                    showSizeChanger: true,
                  }}
                  onChange={handleTableChange}
                />
              </>
            )}

          {report_type === "history_sheeter" && (
            <>
              {showList === "सांख्यिकी" &&
              ((user && user.role === "4") ||
                user.role === "9" ||
                user.role === "10") ? (
                <Table
                  bordered
                  scroll={{ x: "max-content" }}
                  columns={data_history_count.columns}
                  dataSource={data_history_count.rows}
                  pagination={{
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                    showSizeChanger: true,
                  }}
                  onChange={handleTableChange}
                  loading={loading}
                />
              ) : (
                <Table
                  bordered
                  scroll={{ x: "max-content" }}
                  columns={dataHistoryList.columns}
                  dataSource={dataHistoryList.rows}
                  pagination={{
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                    showSizeChanger: true,
                  }}
                  onChange={handleTableChange}
                  className="centered-table"
                  loading={loading}
                />
              )}
            </>
          )}
        </div>
      </div>

      <Drawer
        width={900}
        title={
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              width: "100%",
              gap: 16,
              paddingRight: 8,
            }}
          >
            <div
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 4,
                minWidth: 0,
              }}
            >
              <span style={{ fontWeight: "bold", fontSize: 16 }}>
                आरोपींची यादी
              </span>

              <Typography.Text
                strong
                style={{
                  color: "#1d39c4",
                  fontSize: 16,
                  textAlign: "center",
                  whiteSpace: "normal",
                  lineHeight: "1.4",
                }}
              >
                {info?.graphFilter ? (
                  <>
                    {graphViewType === "preventive_action"
                      ? t("preventive_action")
                      : graphViewType === "shirshak"
                        ? "शीर्षक"
                        : graphViewType === "laghushirshak"
                          ? "लघुशीर्षक"
                          : graphViewType === "date_wise"
                            ? "२ प्लस"
                            : "लघुशीर्षक"}
                    {" : "}
                    {info.graphFilter}
                    <br />
                  </>
                ) : null}
                {info?.graphFilter ? null : (
                  <>
                    {t("police_station")} : {info?.districtName}
                    <br />
                  </>
                )}
                {t("report")} :
                {report_type === "new arophi"
                  ? t("accused_new_cases_statistics")
                  : report_type === "arophi count" ||
                      report_type === "more_than_two_plus_list"
                    ? t("2_plus_report")
                    : report_type === "arophi_new_list"
                      ? t("two_plus_accused_list")
                      : t("2_plus_report")}
                {" ("}
                {filter === "by_distinct"
                  ? report_type === "arophi count" ||
                    report_type === "more_than_two_plus_list"
                    ? t("info_within_police_station_limits")
                    : t("info_within_police_station_crime")
                  : report_type === "arophi count" ||
                      report_type === "more_than_two_plus_list"
                    ? t("data_entered_by_police_station")
                    : t("data_entered_by_police_crime")}
                {")"}
              </Typography.Text>
            </div>

            <div
              style={{
                flexShrink: 0,
                textAlign: "right",
                alignSelf: "flex-start",
                paddingTop: 2,
              }}
            >
              <Text
                type="secondary"
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                  display: "block",
                  marginBottom: 4,
                }}
              >
                {info?.graphFilter ? "एकूण आरोपी" : t("total") || "Total"}
              </Text>
              <span
                style={{
                  fontSize: 26,
                  fontWeight: 700,
                  color: "#1d39c4",
                  lineHeight: 1.1,
                }}
              >
                {loadingList
                  ? (info?.graphCount ?? info?.crimeCount ?? "-")
                  : criminalList.length ||
                    info?.graphCount ||
                    info?.crimeCount ||
                    0}
              </span>
              {info?.graphFilter && !loadingList && (
                <Text
                  type="secondary"
                  style={{
                    fontSize: 11,
                    display: "block",
                    marginTop: 8,
                    lineHeight: 1.3,
                  }}
                >
                  {t("total_crimes")}: {drawerLifetimeCrimesTotal}
                </Text>
              )}
            </div>
          </div>
        }
        maskClosable={false}
        closable={false}
        visible={aropiInfoDrawer}
        footer={
          <div style={{ display: "flex", justifyContent: "flex-start" }}>
            <Button
              danger
              size="small"
              onClick={onCloseAropiInfo}
              style={{ marginRight: 8 }}
            >
              Close
            </Button>
          </div>
        }
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 4,
          }}
        >
          {/* LEFT SIDE DATE */}
          <span>
            {moment(startDate).format("DD-MM-YYYY")}
            {" To "}
            {moment(endDate).format("DD-MM-YYYY")}
          </span>

          {/* RIGHT SIDE BUTTON */}
          <Button
            type="primary"
            size="small"
            disabled={criminalList.length === 0}
            onClick={() => {
              download_csv("आरोपींची यादी");
            }}
          >
            Download Excel
          </Button>
        </div>
        <div className="steps-content mb-4" style={{ marginTop: "2px" }}>
          <AropiInfoTable
            criminalList={criminalList}
            onViewAccusedForm={onViewAccusedForm}
            loading={loadingList}
            show={true}
          />
        </div>
      </Drawer>

      {imageOpen && (
        <ImageView
          imageOpen={imageOpen}
          imageUrl={
            "https://pcimageupload.s3.ap-south-1.amazonaws.com/" + selectedImage
          }
          onClose={closeImageModal}
          id={id}
        />
      )}
      <Modal
        title={t("crime_information")}
        top
        visible={showGunaDetails}
        onOk={closeGunaViewModel}
        onCancel={closeGunaViewModel}
        width={95 + "%"}
      >
        <ViewGunaDetails
          pc_crimetitles={professionals?.pc_crimetitles}
          dataStates={
            Array.isArray(professionals?.criminalViewList?.gunhaInfor) &&
            professionals?.criminalViewList?.gunhaInfor.length > 0
              ? professionals?.criminalViewList?.gunhaInfor
              : []
          }
          address={
            Array.isArray(professionals?.criminalViewList?.basicInfo) &&
            professionals?.criminalViewList?.basicInfo[0]
              ? professionals?.criminalViewList?.basicInfo[0].address
              : ""
          }
          name={
            Array.isArray(professionals?.criminalViewList?.basicInfo) &&
            professionals?.criminalViewList?.basicInfo[0]
              ? professionals?.criminalViewList?.basicInfo[0].name
              : ""
          }
          loading={gunaLoading}
          user_details={user}
          masterId={
            Array.isArray(professionals?.criminalViewList?.basicInfo) &&
            professionals?.criminalViewList?.basicInfo[0]
              ? professionals?.criminalViewList?.basicInfo[0].id
              : ""
          }
          closeGunaViewModel={closeGunaViewModel}
        ></ViewGunaDetails>
      </Modal>
      <Modal
        title={t("preventive_action")}
        top
        visible={showPreventiveDetails}
        onOk={closepreventiveViewModel}
        onCancel={closepreventiveViewModel}
        width={95 + "%"}
      >
        <ViewPrevetiveDetails
          preventiveAction={preventiveAction}
          dataStates={
            Array.isArray(professionals?.criminalViewList?.preventiveInfo) &&
            professionals?.criminalViewList?.preventiveInfo.length > 0
              ? professionals?.criminalViewList?.preventiveInfo
              : []
          }
          name={
            Array.isArray(professionals?.criminalViewList?.basicInfo) &&
            professionals?.criminalViewList?.basicInfo[0]
              ? professionals?.criminalViewList?.basicInfo[0].name
              : ""
          }
          loading={preventiveLoading}
        ></ViewPrevetiveDetails>
      </Modal>
    </>
  );
};
export default connect((state) => ({
  professionals: state.professionals,
}))(AropiReport2Plus);
